import { Component, OnInit, TemplateRef, ChangeDetectorRef, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatDialog } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { FormsService } from '../eSignature/services/forms.service';
import { DatePipe } from '@angular/common'
import { Observable, Subscription } from 'rxjs';
import {
  ChartComponent, ApexAxisChartSeries, ApexChart, ApexXAxis, ApexDataLabels,
  ApexTooltip, ApexStroke, ApexNonAxisChartSeries, ApexResponsive, ApexFill, ApexMarkers
} from "ng-apexcharts";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { SettingService } from '../settings/services/settingService/setting.service';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { SelectFormIconComponent } from 'src/app/middleware/common/selectFormIcon/selectFormIcon.component';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { map, startWith } from 'rxjs/operators';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

export type ChartOptions = {
  seriespie: ApexNonAxisChartSeries;
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  labels: any;
  markers: ApexMarkers;
  fill: ApexFill;
  responsive: ApexResponsive[];
};


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DatePipe]
})
export class DashboardComponent implements OnInit {

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: any;

  @ViewChild("chart") chartpie: ChartComponent;
  public chartOptionspie: any;

  step = 0;

  showCore: boolean = false;
  showContact: boolean = false;
  showCompany: boolean = false;
  showFileManager: boolean = false;
  showTask: boolean = false;
  showCalender: boolean = false;
  showChat: boolean = false;
  showForms: boolean = false;
  showProcessIntelligence: boolean = false;

  showAdminModule: boolean = false;
  showSettingModule: boolean = false;

  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];
  rolesAsssign: any[] = [];
  rolesShow: boolean = false;


  showAddContact: boolean = false;
  Module: string;
  modulename: string = "";
  ModuleNameShow: string = "";

  databaseId: string;
  organizationId: string;
  currentUser: any;
  userId: string = "";
  clickEventsubscriptionCore: Subscription;
  clickEventsubscriptionContact: Subscription;
  clickEventsubscriptionCompany: Subscription;

  FirstWeekFirstDate: string = "";
  FirstWeekLastDate: string = "";
  SecondWeekFirstDate: string = "";
  SecondWeekLastDate: string = "";
  ThirdWeekFirstDate: string = "";
  ThirdWeekLastDate: string = "";
  FourthWeekFirstDate: string = "";
  FourthWeekLastDate: string = "";

  FirstMonthFirstDate: string = "";
  FirstMonthLastDate: string = "";
  SecondMonthFirstDate: string = "";
  SecondMonthLastDate: string = "";
  ThirdMonthFirstDate: string = "";
  ThirdMonthLastDate: string = "";
  FourthMonthFirstDate: string = "";
  FourthMonthLastDate: string = "";
  FifthMonthFirstDate: string = "";
  FifthMonthLastDate: string = "";
  SixthMonthFirstDate: string = "";
  SixthMonthLastDate: string = "";
  SeventhMonthFirstDate: string = "";
  SeventhMonthLastDate: string = "";
  EightMonthFirstDate: string = "";
  EightMonthLastDate: string = "";
  NinthMonthFirstDate: string = "";
  NinthMonthLastDate: string = "";
  TenthMonthFirstDate: string = "";
  TenthMonthLastDate: string = "";
  ElevenMonthFirstDate: string = "";
  ElevenMonthLastDate: string = "";
  TwelveMonthFirstDate: string = "";
  TwelveMonthLastDate: string = "";

  spinner: boolean = false;
  savebuttonshow: boolean = false;
  menuModulesList: any = [] = [];
  CCCList: any = [] = [];
  OfficeIDList: any = [];
  myOfficeID: any;
  CCCType: number = 0;
  CCCfolderId: number = 0;
  clickDashboardRefreshMenusubscription: Subscription;

  taskList: any = [] = [];
  dataSource: any = [] = [];
  @Input() transactionID: number = 0;
  statusGroup: FormGroup;
  ShowNoRecordFound: boolean = false;

  dateFrom: any = null;
  dateTo: any = null;
  isOverDue = false;
  taskStatusList: any = [] = [];
  currentType = "Today";
  currentSignatureView = "Inbox"
  currentCoreType = "Core"

  orgModuleNameCore: string = "";
  orgModuleNameContact: string = "";
  orgModuleNameCompany: string = "";

  completedTaskStatusID: any = 0;
  formIcon: any;
  name: string;
  emailid: string;
  SendEmailList: any[];
  mobileNo: string;
  addButtonShow: boolean;
  SendMobileList: any[];
  AddTaskListEmailResult: any;
  ButtonForFolder: boolean;
  taskListFolderID: any;
  taskTemplateID: any;
  showMobile: boolean;
  AttachChecked: boolean = false;
  AssigneeChecked: any;
  NotifyChecked: any;
  showEmail: boolean;
  ButtonForUploadImage: boolean;
  sendButton: boolean;
  currentTemplateId: any;
  sendForSign: any;
  showTaskTempalteDetail: boolean;
  clickFetchDashboardfavourite: Subscription;
  attachedToContactList: any[];
  contactsSelectedList: any = [];
  selectedCoreEmailID: string = '';
  relationList: any = [];
  SendEmailLater: boolean = false;
  isOnlyTaskView = true;


  constructor(private formBuilder: FormBuilder, private router: Router, private dialog: MatDialog, private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef, private reusableClass: ReusableClasses, private encryptionAlgo: EncryptionService,
    private formsService: FormsService, public datepipe: DatePipe, private statusConstant: StatusConstant,
    private toastr: ToastrService,
    private taskService: SettingService,
    private loaderService: LoaderService
  ) {
    this.statusGroup = new FormGroup({});
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices = [];
    offices = JSON.parse(sessionStorage.getItem('officeList'));
    if (offices.length > 0) {
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID)
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  quickLinkAPIArray: any;
  ngOnInit(): void {

    // this.quickLinkAPIArray= {
    //   Forms:[{type:2,icon:"adjust",formType:1,ID:242,Name:"core participant 4"}],
    //   Tasklists:[],
    //   Folders:[{type:3,icon:"folder",formType:0,ID:915,Name:"Doc Automate"}],
    //   Urls:[{type:1,icon:"add_to_queue",formType:1,ID:0,URL:"https://docs.google.com/document/d/17MGbaeBMdt0JWpNrPw4uk8J3c_TqtVCzO5ivd3OcHQA/edit?tab=t.7ycuotwawd7l", Name:"Bug Document"}]
    // }
    this.clickFetchDashboardfavourite = this._dataSharingService.getFetchDashboardfavourite().subscribe((val: boolean) => {
      if (val) {
        var offices = [];
        offices = JSON.parse(sessionStorage.getItem('officeList'));
        if (offices.length > 0) {
          offices.forEach(oe => {
            this.OfficeIDList.push(oe.officeID)
            if (oe.isMyoffice == true) {
              this.myOfficeID = oe.officeID;
              this.DashboardFavoriteItems();
            }
          });
        }
      }
    });
    this.DashboardFavoriteItems();

    sessionStorage.setItem('edashboard', "false");
    this.userId = this.currentUser.UID;
    this.getThirdPartyApplicationList();
    this.clickDashboardRefreshMenusubscription = this._dataSharingService.getRequestMenu().subscribe((result) => {
      if (result == true) {
        this.currentCoreType = "Core";
        const encryptedtoken = sessionStorage.getItem('userToken');
        const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
        this.databaseId = sessionStorage.getItem('databaseId');
        this.organizationId = sessionStorage.getItem('organizationID');
        this.currentUser = jwt_decode(token);
        var offices = [];
        offices = JSON.parse(sessionStorage.getItem('officeList'));
        if (offices.length > 0) {
          offices.forEach(oe => {
            this.OfficeIDList.push(oe.officeID)
            if (oe.isMyoffice == true)
              this.myOfficeID = oe.officeID;
          });
        }

        this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));

        var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));

        this.menuModulesList = menuModulesList.filter(x => x.mainModuleName == 'Core' || x.mainModuleName == 'Contact'
          || x.mainModuleName == 'Company' || x.mainModuleName == 'File Manager');

        if (this.menuModulesList.length > 0) {
          this.menuModulesList.forEach(e => {
            e.note = '0 added this week'
          });
        }

        // var ReqModel={
        //   children: null,
        //   folderID: 0,
        //   icon: "dashboard",
        //   mainModuleID: 1,
        //   mainModuleName: "Notes",
        //   orgModuleName: "Notes",
        //   parentID: 0,
        //   position: 0,
        //   isAssign:true
        // }
        // this.menuModulesList.push(ReqModel);

        // if(this.menuModulesList.length>0){
        //   this.menuModulesList.forEach(e => { 
        //     e.note='0 added this week'      
        //   }); 
        // }      

        var core = [];
        var contact = [];
        var company = [];
        core = menuModulesList.filter(x => x.mainModuleName == 'Core');
        if (core.length > 0) {
          this.orgModuleNameCore = core[0].orgModuleName;
        } else {
          this.orgModuleNameCore = "";
        }

        contact = menuModulesList.filter(x => x.mainModuleName == 'Contact');
        if (contact.length > 0) {
          this.orgModuleNameContact = contact[0].orgModuleName;
        } else {
          this.orgModuleNameContact = "";
        }

        company = menuModulesList.filter(x => x.mainModuleName == 'Company');
        if (company.length > 0) {
          this.orgModuleNameCompany = company[0].orgModuleName;
        } else {
          this.orgModuleNameCompany = "";
        }

        this.CCCList = menuModulesList.filter(x => x.mainModuleName == 'Core' || x.mainModuleName == 'Contact' || x.mainModuleName == 'Company');
        this.CCCList = this.CCCList.filter(x => x.isAssign == true);

        var Module = [];
        Module = menuModulesList.filter(x => x.mainModuleName == 'Dashboard');
        if (Module.length > 0) {
          this.ModuleNameShow = Module[0].orgModuleName;
        }

        var SelectedCCC = [];

        SelectedCCC = menuModulesList.filter(x => x.mainModuleName == 'Core');
        if (SelectedCCC.length > 0) {
          this.orgModuleNameCore = SelectedCCC[0].orgModuleName;
          this.CorefolderID = SelectedCCC[0].folderID;
          this.CCCType = 1;
          this.CCCfolderId = this.CorefolderID;
        } else if (SelectedCCC.length == 0) {
          SelectedCCC = menuModulesList.filter(x => x.mainModuleName == 'Contact');
          if (SelectedCCC.length > 0) {
            this.ContactfolderID = SelectedCCC[0].folderID;
            this.CCCType = 2;
            this.CCCfolderId = this.ContactfolderID;
          }
          else if (SelectedCCC.length == 0) {
            SelectedCCC = menuModulesList.filter(x => x.mainModuleName == 'Company');
            if (SelectedCCC.length > 0) {
              this.CompanyfolderID = SelectedCCC[0].folderID;
              this.CCCType = 3;
              this.CCCfolderId = this.CompanyfolderID;
            }
          }
        }

        this.SelectedCCC = SelectedCCC[0].orgModuleName;
        this.RecentlySelectedType = SelectedCCC[0].orgModuleName;

        this.getDashboardStats();
        this.getRecentlyCCCList(this.CorefolderID, this.RecentlySelectedType);
        this.getInboxProjects(this.pageModelData);
        this.GetNotes(0); //--0 ALL , 1- Global, 2- Personal 
        this.getTaskStatus();
       // this.getTaskList('Today');
        this.getTaskListByType(2);
      }
    });

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));

    this.menuModulesList = menuModulesList.filter(x => x.mainModuleName == 'Core' || x.mainModuleName == 'Contact'
      || x.mainModuleName == 'Company' || x.mainModuleName == 'File Manager');

    // var ReqModel={
    //   children: null,
    //   folderID: 0,
    //   icon: "dashboard",
    //   mainModuleID: 1,
    //   mainModuleName: "Notes",
    //   orgModuleName: "Notes",
    //   parentID: 0,
    //   position: 0,
    //   isAssign:true
    // }
    // this.menuModulesList.push(ReqModel);

    if (this.menuModulesList.length > 0) {
      this.menuModulesList.forEach(e => {
        e.note = '0 added this week'
      });
    }

    this.CCCList = menuModulesList.filter(x => x.mainModuleName == 'Core' || x.mainModuleName == 'Contact' || x.mainModuleName == 'Company');
    this.CCCList = this.CCCList.filter(x => x.isAssign == true);

    var core = [];
    var contact = [];
    var company = [];
    core = menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (core.length > 0) {
      this.orgModuleNameCore = core[0].orgModuleName;
    } else {
      this.orgModuleNameCore = "";
    }

    contact = menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (contact.length > 0) {
      this.orgModuleNameContact = contact[0].orgModuleName;
    } else {
      this.orgModuleNameContact = "";
    }

    company = menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (company.length > 0) {
      this.orgModuleNameCompany = company[0].orgModuleName;
    } else {
      this.orgModuleNameCompany = "";
    }
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == 'Dashboard');
    if (Module.length > 0) {
      this.ModuleNameShow = Module[0].orgModuleName;
    }

    var SelectedCCC = [];

    SelectedCCC = menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
      this.CCCType = 1;
      this.CCCfolderId = this.CorefolderID;
    } else if (SelectedCCC.length == 0) {
      SelectedCCC = menuModulesList.filter(x => x.mainModuleName == 'Contact');
      if (SelectedCCC.length > 0) {
        this.ContactfolderID = SelectedCCC[0].folderID;
        this.CCCType = 2;
        this.CCCfolderId = this.ContactfolderID;
      }
      else if (SelectedCCC.length == 0) {
        SelectedCCC = menuModulesList.filter(x => x.mainModuleName == 'Company');
        if (SelectedCCC.length > 0) {
          this.CompanyfolderID = SelectedCCC[0].folderID;
          this.CCCType = 3;
          this.CCCfolderId = this.CompanyfolderID;
        }
      }
    }

    this.SelectedCCC = SelectedCCC[0].orgModuleName;
    this.RecentlySelectedType = SelectedCCC[0].orgModuleName;

    sessionStorage.setItem('HeaderModuleName', this.ModuleNameShow);

    this._dataSharingService.sendSelectedModuleName(this.ModuleNameShow);
    this._dataSharingService.sendShowFormsSiderbar(this.ModuleNameShow);

    this.clickEventsubscriptionCore = this._dataSharingService.getSaveUserForCore().subscribe(() => {
      this.getDashboardStats();
      this.GetDashboard3cGraphData(1, this.WMY);
      this.getRecentlyCCCList(this.CorefolderID, this.RecentlySelectedType);
    });

    this.clickEventsubscriptionContact = this._dataSharingService.getSaveUserForContact().subscribe(() => {
      this.getDashboardStats();
      this.GetDashboard3cGraphData(2, this.WMY);
      this.getRecentlyCCCList(this.ContactfolderID, this.RecentlySelectedType);
    });

    this.clickEventsubscriptionCompany = this._dataSharingService.getSaveUserForCompany().subscribe(() => {
      this.getDashboardStats();
      this.GetDashboard3cGraphData(3, this.WMY);
      this.getRecentlyCCCList(this.CompanyfolderID, this.RecentlySelectedType);
    });


    // var date = new Date();
    // var d = date.getUTCDate();
    // date.setDate(date.getDate()-6);
    // var lastDay =this.datepipe.transform(date, 'yyyy-MM-dd');
    // var firstDay =this.datepipe.transform(d, 'yyyy-MM-dd');      

    var date = this.getNowUTC();
    var d = this.getNowUTC();
    date.setDate(date.getDate() - 6);
    let lastDay = this.datepipe.transform(d, 'yyyy-MM-dd');
    let firstDay = this.datepipe.transform(date, 'yyyy-MM-dd');

    this.GetDashboard3cGraphData(this.CCCType, 'Week'); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
    this.GetDashboardSignatureGraphData(firstDay, lastDay);
    this.GetNotes(0); //--0 ALL , 1- Global, 2- Personal  
    this.getDashboardStats();
    this.getRecentlyCCCList(this.CCCfolderId, this.RecentlySelectedType);
    this.getInboxProjects(this.pageModelData);
    this.addNotesForm = this.formBuilder.group({
      notes: ['', Validators.required],
      color: ['', Validators.required]
    });

    this.addQuickLinkForm = this.formBuilder.group({
      quickLink: new FormControl("#f5d428"),
    });
    this.getTaskStatus();
    //this.getTaskList('Today');
    this.getTaskListByType(2);
  }

  switchTaskView(isOnlyTaskView: boolean){
    this.taskList = [];    
    this.isOnlyTaskView = isOnlyTaskView;
    if(isOnlyTaskView==true){
     this.getTaskListByType(1);
    }else{
      this.getTaskList('Today');
    }
  }

  getTaskListByType(taskType: number){ 
    this.currentType = taskType == 1 ? 'MyTaskList' : 'SharedTaskList';
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      type: taskType
    };
    this.loaderService.show();
    this.taskService.getDashboardFolderTasklists(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.taskList = this.responseHolder.data;
          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        } else {
          this.loaderService.hide();
        }
      }
    });

    // if(taskType ==1){

    // }
    // else{

    // }
  }  


  openTaskListUrl(list, isOpen = false) {
    if (list.token != null && isOpen == true) {
      let params = decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);     

      decryptedToken.isOpenURL = true;
      decryptedToken.isLoggedInUser = true;
      decryptedToken.email = sessionStorage.getItem('email');
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
      window.open(URL, '_blank');   
    }
    
  }

  openInternalTaskList(link) {
    const encodedData = this.encodeData(link);
    const url = this.router.serializeUrl(
    this.router.createUrlTree(['/task'], { queryParams: { data: encodedData } })
    );
    window.open(url, '_blank');
  }

  selectIcon() {
    const dialogRef = this.dialog.open(SelectFormIconComponent, {

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.formIcon = result;
        // this.iconName = result.name;  
      }
    });
  }

  deleteQuickLink(link: any) {
    this.showHideQuickLink();
    this.RemoveDashboardFavoriteItem(link)
  }

  RemoveDashboardFavoriteItem(link: any) {
    var message = `Are you sure you want to delete record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var ReqModel = {
          FavoriteID: link.favouriteID,//this.selectedRecordDeleteArray,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
          officeID: this.myOfficeID,
        };
        this.formsService.RemoveDashboardFavoriteItem(ReqModel).subscribe((response) => {

          if (response != undefined) {
            this.DashboardFavoriteItems();
            this.toastr.success('Quick Link Deleted successfully.', '', {
              timeOut: 3000,
            });
          }
        });
      }
    });
  }

  showHideQuickLink() {
    // Find all elements with the class 'showOnClick'
    const elements = document.querySelectorAll('.showOnClick');
    // Loop through each element
    elements.forEach(element => {
      // Check if the element has the class 'hideCrossBtn'
      if (element.classList.contains('hideCrossBtn')) {
        // If it has the class, remove it
        element.classList.remove('hideCrossBtn');
      } else {
        // If it doesn't have the class, add it
        element.classList.add('hideCrossBtn');
      }
    });
  }


  openPopup(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'addThirdParty'
    });    
  }
 
  DashboardFavoriteItems() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show()
    this.formsService.DashboardFavoriteItems(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.quickLinkAPIArray = this.responseHolder.data;
        } else {
          this.toastr.error('Error occurred.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  addDashboardQuicklink(addQuickLinkForm) {
    if (!(document.getElementById("urlname") as HTMLInputElement).value || !(document.getElementById("urlname") as HTMLInputElement).value || !this.formIcon) {
      this.toastr.warning('Please provide a Name, Link, and select an Icon before saving.', '', {
        timeOut: 3000,
      });
      return;
    }
    var ReqModel = {
      id: 0,
      name: (document.getElementById("urlname") as HTMLInputElement).value,
      favoriteType: 4, //form
      url: (document.getElementById("urllink") as HTMLInputElement).value,
      icon: this.formIcon.icon,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      color: addQuickLinkForm.quickLink,
    };
    this.loaderService.show()
    this.formsService.AddDashboardFavoriteItem(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.close();
        this.formIcon = "";
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.DashboardFavoriteItems();
          this.toastr.success('Dashboard Quick Added successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('Error occurred.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  openExternalLink(link: any): void {
    if (link) {
      // Check if the link already starts with 'http://' or 'https://'
      if (!link.startsWith('http://') && !link.startsWith('https://')) {
        // If not, prepend 'https://' to the link
        link = 'https://' + link;
      }
      // Open the link in a new tab
      window.open(link, '_blank', 'noopener,noreferrer');
    } else {
      console.error("Invalid link provided.");
    }
  }

  encodeData(data: any): string {
    return btoa(JSON.stringify(data)); // Convert object to Base64 string
  }

  openFilemanagerFolder(link: any) {
    const encodedData = this.encodeData(link);
    this.router.navigate(['/filemanager'], { queryParams: { data: encodedData } });
  }

  openProject(form) {
    var ReqModel = {
      formFolderId: 0,
      formId: form.id,
      formName: form.name, //form.name,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
    };
    this.loaderService.show()
    this.formsService.UseFormsTemplateForProject(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          // if(form.type == 2 && form.formType==1){
          // if(this.parentID>0)
          // sessionStorage.setItem('FolderOpenId',(this.parentID).toString());
          // else
          //sessionStorage.setItem('FolderOpenId',(form.parentID).toString());        
          sessionStorage.setItem('projectID', response.data.projectID);
          sessionStorage.setItem('type', (1).toString());  // 1 for Project and 2 for Template         
          this.router.navigate(['/esignature/second']);
          sessionStorage.setItem('HeaderModuleName', 'Template');
          sessionStorage.setItem('isSharedWithMeForm', 'false');
          sessionStorage.setItem('MasterTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateTabularForm', 'false');
          sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateWebForm', 'false');
          this._dataSharingService.sendSelectedModuleName('Forms');
          this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
          //   }
          // } else {
          //   this.loaderService.hide();
          // }
        } else {
          this.loaderService.hide();
        }
      }
    });

  }

  // pageModelData = {
  //   pageIndex: 0,
  //   pageSize: 10,
  //   searchValue: '',
  // };  

  // linkclick(link){
  //   if (link == "Admin"){
  //     this.router.navigate(['/admin']); 
  //     sessionStorage.setItem('HeaderModuleName', link);
  //     this._dataSharingService.sendSelectedModuleName(link); 
  //   }
  //   if (link == "Settings"){
  //     this.router.navigate(['/settings']); 
  //     sessionStorage.setItem('HeaderModuleName', link);
  //     this._dataSharingService.sendSelectedModuleName(link); 
  //   }    
  // }      

  addNew(folder) {
    this.Module = folder.orgModuleName;
    if (folder.mainModuleName == "Core" || folder.mainModuleName == "Contact" || folder.mainModuleName == "Company") {
      this.showAddContact = !this.showAddContact;
    }

    if (folder.mainModuleName == "Forms") {
      sessionStorage.removeItem("ProjectName");
      sessionStorage.removeItem("projectID");
      sessionStorage.setItem('type', '1');
      sessionStorage.setItem('ImportTemplateShow', 'true');
      sessionStorage.setItem('MasterTemplatePDFForm', 'false');
      sessionStorage.setItem('MasterTemplateTabularForm', 'false');
      sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
      sessionStorage.setItem('MasterTemplateWebForm', 'false');
      this._dataSharingService.sendSelectedProjectName("");
      this._dataSharingService.SendCurrentFormContact(null);
      this.router.navigate(['/esignature/first']);
    }
    if (folder.mainModuleName == "File Manager") {
      this.router.navigate(['/filemanager']);
      this._dataSharingService.SendCurrentFormContactFileManager(null);
      this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(null);
      //this._dataSharingService.sendRefreshListForFileManagerAddFolder(0);
      this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
      this._dataSharingService.sendSelectedDocForGoogleDrive(null);
    }
    if (folder.mainModuleName == "Chat") {
      this._dataSharingService.sendAddAttachmentFile(null);
      this._dataSharingService.sendMessageUserOrGroup(null);
      this._dataSharingService.sendSelectedChatParticipant(null);
      this._dataSharingService.sendDeleteChatGroup(null);
      this.router.navigate(['/chat']);
    }
  }

  getClose(message) {
    this.showAddContact = message;
  }

  redirect(folder) {
    sessionStorage.removeItem("edashboard");
    if (folder.mainModuleName == "Core") {
      var showList = sessionStorage.getItem('coreshowListing');
      if (showList == 'true') {
        this.router.navigate(['/core/listing']);
        return;
      }
      var showkanban = sessionStorage.getItem('coreshowkanban');
      if (showkanban == 'true') {
        this.router.navigate(['/core/kanbanview'], {});
        return;
      }

      var showGrouping = sessionStorage.getItem('coreshowGrouping');
      if (showGrouping == 'true') {
        sessionStorage.setItem("gridViewModuleName", "Core");
        this._dataSharingService.sendGroupingList3C();
        this.router.navigate(['gridView']);
        return;
      } else {
        this.router.navigate(['/core/listing']);
      }
    }
    if (folder.mainModuleName == "Contact") {
      var showList = sessionStorage.getItem('contactshowListing');
      if (showList == 'true') {
        this.router.navigate(['/contact/listing']);
        return;
      }
      var showkanban = sessionStorage.getItem('contactshowkanban');
      if (showkanban == 'true') {
        this.router.navigate(['/contact/kanbanview'], {});
        return;
      }
      var showGrouping = sessionStorage.getItem('contactshowGrouping');
      if (showGrouping == 'true') {
        sessionStorage.setItem("gridViewModuleName", "Contact");
        this._dataSharingService.sendGroupingList3C();
        this.router.navigate(['gridView']);
        return;
      } else {
        this.router.navigate(['/contact/listing']);
      }
      // this.router.navigate(['/contact/listing']);
    }
    if (folder.mainModuleName == "Company") {
      var showList = sessionStorage.getItem('companyshowListing');
      if (showList == 'true') {
        this.router.navigate(['/company/listing']);
        return;
      }
      var showkanban = sessionStorage.getItem('companyshowkanban');
      if (showkanban == 'true') {
        this.router.navigate(['/company/kanbanview'], {});
        return;
      }
      var showGrouping = sessionStorage.getItem('companyshowGrouping');
      if (showGrouping == 'true') {
        sessionStorage.setItem("gridViewModuleName", "Company");
        this._dataSharingService.sendGroupingList3C();
        this.router.navigate(['gridView']);
        return;
      } else {
        this.router.navigate(['/company/listing']);
      }
      //this.router.navigate(['/company/listing']);
    }
    if (folder.mainModuleName == "Forms") {
      sessionStorage.removeItem("ProjectName");
      sessionStorage.removeItem("projectID");
      sessionStorage.setItem('type', '1');
      sessionStorage.setItem('ImportTemplateShow', 'true');
      sessionStorage.setItem('isSharedWithMeForm', 'false');
      sessionStorage.setItem('MasterTemplatePDFForm', 'false');
      sessionStorage.setItem('MasterTemplateTabularForm', 'false');
      sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
      sessionStorage.setItem('MasterTemplateWebForm', 'false');
      this._dataSharingService.sendSelectedProjectName("");
      this._dataSharingService.SendCurrentFormContact(null);
      this.router.navigate(['/esignature']);
    }
    if (folder.mainModuleName == "File Manager") {
      this.router.navigate(['/filemanager']);
      this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(null);
      this._dataSharingService.sendRefreshListForFileManagerAddFolder(0);
      this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
      this._dataSharingService.sendSelectedDocForGoogleDrive(null);
    }
    if (folder.mainModuleName == "Chat") {
      this._dataSharingService.sendAddAttachmentFile(null);
      this._dataSharingService.sendMessageUserOrGroup(null);
      this._dataSharingService.sendSelectedChatParticipant(null);
      this._dataSharingService.sendDeleteChatGroup(null);
      this.router.navigate(['/chat']);
    }
  }

  // For 3C Graph (area chart)
  CCCGraph: any = [] = [];
  RecordCount: number[] = [];
  dates: string[] = [];

  getDaysArray = function (start, end) {
    for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      this.dates.push(this.datepipe.transform(dt, 'dd'))
    }
    return this.dates;
  };

  GetDashboard3cGraphData(type, WMY) {
    var firstDay;
    var lastDay;
    if (WMY == "Week") {
      this.WMY = "Week";
      // var date =new Date();
      // var d = new Date();
      // d.setDate(d.getDate()-6);
      // lastDay =this.datepipe.transform(date, 'yyyy-MM-dd');
      // firstDay =this.datepipe.transform(d, 'yyyy-MM-dd'); 
      var date = this.getNowUTC();
      var d = this.getNowUTC();
      date.setDate(date.getDate() - 6);
      lastDay = this.datepipe.transform(d, 'yyyy-MM-dd');
      firstDay = this.datepipe.transform(date, 'yyyy-MM-dd');
    }
    if (WMY == "Month") {
      this.WMY = "Month";
      // var date =new Date();
      // var d = new Date();
      // d.setDate(d.getDate()-27);
      // lastDay =this.datepipe.transform(date, 'yyyy-MM-dd');
      // firstDay =this.datepipe.transform(d, 'yyyy-MM-dd');
      var date = this.getNowUTC();
      var d = this.getNowUTC();
      date.setDate(date.getDate() - 27);
      lastDay = this.datepipe.transform(d, 'yyyy-MM-dd');
      firstDay = this.datepipe.transform(date, 'yyyy-MM-dd');
      this.CCCMonth();
    }
    if (WMY == "Year") {
      this.WMY = "Year";
      var start = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
      var end = new Date(new Date().getFullYear(), 11, 31, 0, 0, 0, 0);
      lastDay = this.datepipe.transform(end, 'yyyy-MM-dd');
      firstDay = this.datepipe.transform(start, 'yyyy-MM-dd');
      this.CCCYear();
    }

    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      email: sessionStorage.getItem('email'),
      officeID: this.myOfficeID,
      folderID: this.CCCfolderId,
      startDate: firstDay,
      endDate: lastDay,
      type: type // 1-Core ,2-Contact ,3-Company
    }
    this.formsService.getDashboard3cGraphData(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.CCCGraph = response.data.stats;
        this.RecordCount = [];
        this.dates = [];

        //For Week
        if (WMY == "Week") {
          const first = new Date(firstDay);
          var dayfirst = new Date(first.getTime() + (first.getTimezoneOffset() * 60000));
          const last = new Date(lastDay);
          var daylast = new Date(last.getTime() + (last.getTimezoneOffset() * 60000));
          this.dates = this.getDaysArray(new Date(dayfirst), new Date(daylast));
          for (var i = 0; i < this.dates.length; i++) {
            var check = [];
            check = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'dd') == this.dates[i]);
            if (check.length > 0) {
              this.RecordCount.push(check[0].count);
            } else {
              this.RecordCount.push(0);
            }
          }
        }

        //For Month
        if (WMY == "Month") {
          this.dates = ['W1', "W2", "W3", "W4"];
          //this.RecordCount=[1,0,2,0];  
          var Week1data = [];
          var Week2data = [];
          var Week3data = [];
          var Week4data = [];

          // 1st Week Data
          Week1data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FirstWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FirstWeekLastDate, 'yyyy-MM-dd'));
          if (Week1data.length > 0) {
            var Total = Week1data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // 2nd Week Data
          Week2data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SecondWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SecondWeekLastDate, 'yyyy-MM-dd'));
          if (Week2data.length > 0) {
            var Total = Week2data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // 3rd Week Data
          Week3data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.ThirdWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.ThirdWeekLastDate, 'yyyy-MM-dd'));
          if (Week3data.length > 0) {
            var Total = Week3data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // 4th Week Data
          Week4data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FourthWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FourthWeekLastDate, 'yyyy-MM-dd'));
          if (Week4data.length > 0) {
            var Total = Week4data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

        }

        //For Year
        if (WMY == "Year") {
          this.dates = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          //this.RecordCount=[1,0,2,0,4,3,7,5,9,6,4,7];

          var Jandata = [];
          var Febdata = [];
          var Mardata = [];
          var Aprdata = [];
          var Maydata = [];
          var Jundata = [];
          var Juldata = [];
          var Augdata = [];
          var Septdata = [];
          var Octdata = [];
          var Novdata = [];
          var Decdata = [];

          // Jan Data 1
          Jandata = this.CCCGraph.filter(m => (this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FirstMonthFirstDate, 'yyyy-MM-dd')) && (this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FirstMonthLastDate, 'yyyy-MM-dd')));
          if (Jandata.length > 0) {
            var Total = Jandata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Feb Data 2
          Febdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SecondMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SecondMonthLastDate, 'yyyy-MM-dd'));
          if (Febdata.length > 0) {
            var Total = Febdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // March Data 3
          Mardata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.ThirdMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.ThirdMonthLastDate, 'yyyy-MM-dd'));
          if (Mardata.length > 0) {
            var Total = Mardata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // April Data 4
          Aprdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FourthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FourthMonthLastDate, 'yyyy-MM-dd'));
          if (Aprdata.length > 0) {
            var Total = Aprdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

          // May Data 5
          Maydata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FifthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FifthMonthLastDate, 'yyyy-MM-dd'));
          if (Maydata.length > 0) {
            var Total = Maydata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

          // Jun Data 6
          Jundata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SixthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SixthMonthLastDate, 'yyyy-MM-dd'));
          if (Jundata.length > 0) {
            var Total = Jundata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // July Data 7
          Juldata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SeventhMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SeventhMonthLastDate, 'yyyy-MM-dd'));
          if (Juldata.length > 0) {
            var Total = Juldata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Aug Data 8
          Augdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.EightMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.EightMonthLastDate, 'yyyy-MM-dd'));
          if (Augdata.length > 0) {
            var Total = Augdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Sept Data 9
          Septdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.NinthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.NinthMonthLastDate, 'yyyy-MM-dd'));
          if (Septdata.length > 0) {
            var Total = Septdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Oct Data 10
          Octdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.TenthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.TenthMonthLastDate, 'yyyy-MM-dd'));
          if (Octdata.length > 0) {
            var Total = Octdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Nov Data 11
          Novdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.ElevenMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.ElevenMonthLastDate, 'yyyy-MM-dd'));
          if (Novdata.length > 0) {
            var Total = Novdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Dec Data 12
          Decdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.TwelveMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.TwelveMonthLastDate, 'yyyy-MM-dd'));
          if (Decdata.length > 0) {
            var Total = Decdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

        }

        var name = "";
        if (type == 1) {
          // name="Core";
          var SelectedValue = this.CCCList.filter(x => x.mainModuleName == "Core");
          name = SelectedValue[0].orgModuleName;
        }
        if (type == 2) {
          // name="Contact";
          var SelectedValue = this.CCCList.filter(x => x.mainModuleName == "Contact");
          name = SelectedValue[0].orgModuleName;
        }
        if (type == 3) {
          // name="Company";
          var SelectedValue = this.CCCList.filter(x => x.mainModuleName == "Company");
          name = SelectedValue[0].orgModuleName;
        }


        this.chartOptions = {
          series: [
            {
              name: name,
              data: this.RecordCount,
            }
          ],
          chart: {
            toolbar: {
              show: false
            },
            height: 150,
            // width: 420,  
            type: "area"
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth"
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 10, 100]
            }
          },
          xaxis: {
            type: "string",
            categories: this.dates,
          },
          tooltip: {
            x: {
              format: "string",
            }
          }
        };

      }
      else {
        this.CCCGraph = [];
        this.RecordCount = [];
        this.dates = [];

        //For Week
        if (WMY == "Week") {
          const first = new Date(firstDay);
          var dayfirst = new Date(first.getTime() + (first.getTimezoneOffset() * 60000));
          const last = new Date(lastDay);
          var daylast = new Date(last.getTime() + (last.getTimezoneOffset() * 60000));

          this.dates = this.getDaysArray(new Date(dayfirst), new Date(daylast));
          for (var i = 0; i < this.dates.length; i++) {
            var check = [];
            check = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'dd') == this.dates[i]);
            if (check.length > 0) {
              this.RecordCount.push(check[0].count);
            } else {
              this.RecordCount.push(0);
            }
          }
        }

        //For Month
        if (WMY == "Month") {
          // var date=[];
          // date=this.getDaysArrayMonthYear(new Date(firstDay),new Date(lastDay));
          this.dates = ['W1', "W2", "W3", "W4"];
          //this.RecordCount=[1,0,2,0];  
          var Week1data = [];
          var Week2data = [];
          var Week3data = [];
          var Week4data = [];

          // 1st Week Data
          Week1data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FirstWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FirstWeekLastDate, 'yyyy-MM-dd'));
          if (Week1data.length > 0) {
            var Total = Week1data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // 2nd Week Data
          Week2data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SecondWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SecondWeekLastDate, 'yyyy-MM-dd'));
          if (Week2data.length > 0) {
            var Total = Week2data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // 3rd Week Data
          Week3data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.ThirdWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.ThirdWeekLastDate, 'yyyy-MM-dd'));
          if (Week3data.length > 0) {
            var Total = Week3data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // 4th Week Data
          Week4data = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FourthWeekFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FourthWeekLastDate, 'yyyy-MM-dd'));
          if (Week4data.length > 0) {
            var Total = Week4data.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

        }

        //For Year
        if (WMY == "Year") {
          this.dates = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          //this.RecordCount=[1,0,2,0,4,3,7,5,9,6,4,7];

          var Jandata = [];
          var Febdata = [];
          var Mardata = [];
          var Aprdata = [];
          var Maydata = [];
          var Jundata = [];
          var Juldata = [];
          var Augdata = [];
          var Septdata = [];
          var Octdata = [];
          var Novdata = [];
          var Decdata = [];

          // Jan Data 1
          Jandata = this.CCCGraph.filter(m => (this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FirstMonthFirstDate, 'yyyy-MM-dd')) && (this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FirstMonthLastDate, 'yyyy-MM-dd')));
          if (Jandata.length > 0) {
            var Total = Jandata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Feb Data 2
          Febdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SecondMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SecondMonthLastDate, 'yyyy-MM-dd'));
          if (Febdata.length > 0) {
            var Total = Febdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // March Data 3
          Mardata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.ThirdMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.ThirdMonthLastDate, 'yyyy-MM-dd'));
          if (Mardata.length > 0) {
            var Total = Mardata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // April Data 4
          Aprdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FourthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FourthMonthLastDate, 'yyyy-MM-dd'));
          if (Aprdata.length > 0) {
            var Total = Aprdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

          // May Data 5
          Maydata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.FifthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.FifthMonthLastDate, 'yyyy-MM-dd'));
          if (Maydata.length > 0) {
            var Total = Maydata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

          // Jun Data 6
          Jundata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SixthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SixthMonthLastDate, 'yyyy-MM-dd'));
          if (Jundata.length > 0) {
            var Total = Jundata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // July Data 7
          Juldata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.SeventhMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.SeventhMonthLastDate, 'yyyy-MM-dd'));
          if (Juldata.length > 0) {
            var Total = Juldata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Aug Data 8
          Augdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.EightMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.EightMonthLastDate, 'yyyy-MM-dd'));
          if (Augdata.length > 0) {
            var Total = Augdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Sept Data 9
          Septdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.NinthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.NinthMonthLastDate, 'yyyy-MM-dd'));
          if (Septdata.length > 0) {
            var Total = Septdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Oct Data 10
          Octdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.TenthMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.TenthMonthLastDate, 'yyyy-MM-dd'));
          if (Octdata.length > 0) {
            var Total = Octdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Nov Data 11
          Novdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.ElevenMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.ElevenMonthLastDate, 'yyyy-MM-dd'));
          if (Novdata.length > 0) {
            var Total = Novdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }
          // Dec Data 12
          Decdata = this.CCCGraph.filter(m => this.datepipe.transform(m.date, 'yyyy-MM-dd') >= this.datepipe.transform(this.TwelveMonthFirstDate, 'yyyy-MM-dd') && this.datepipe.transform(m.date, 'yyyy-MM-dd') <= this.datepipe.transform(this.TwelveMonthLastDate, 'yyyy-MM-dd'));
          if (Decdata.length > 0) {
            var Total = Decdata.reduce(function (prev, cur) {
              return prev + cur.count;
            }, 0);
            this.RecordCount.push(Total);
          }
          else {
            this.RecordCount.push(0);
          }

        }



        var name = "";
        if (type == 1) {
          // name="Core";
          var SelectedValue = this.CCCList.filter(x => x.mainModuleName == "Core");
          name = SelectedValue[0].orgModuleName;
        }
        if (type == 2) {
          var SelectedValue = this.CCCList.filter(x => x.mainModuleName == "Contact");
          name = SelectedValue[0].orgModuleName;
          // name="Contact";
        }
        if (type == 3) {
          // name="Company";
          var SelectedValue = this.CCCList.filter(x => x.mainModuleName == "Company");
          name = SelectedValue[0].orgModuleName;
        }
        this.chartOptions = {
          series: [
            {
              name: name,
              data: this.RecordCount,
            }
          ],
          chart: {
            toolbar: {
              show: false
            },
            height: 150,
            // width: 420,  
            type: "area"
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth"
          },
          xaxis: {
            type: "string",
            categories: this.dates,
          },
          tooltip: {
            x: {
              format: "string",
              //format: "numeric"
            }
          }
        };
      }
    });
  }


  SelectedCCC: string = "";
  SelectedWMY: string = "Week";
  WMY: string = "Week";

  CCCOptionSelect(event) {
    var SelectedValue = this.CCCList.filter(x => x.orgModuleName == event.value);
    if (SelectedValue[0].mainModuleName == "Core") {
      this.SelectedCCC = SelectedValue[0].orgModuleName;
      if (this.SelectedWMY == "Week") {
        this.WMY = "Week";
        this.GetDashboard3cGraphData(1, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
      if (this.SelectedWMY == "Month") {
        this.WMY = "Month";
        this.GetDashboard3cGraphData(1, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
      if (this.SelectedWMY == "Year") {
        this.WMY = "Year";
        this.GetDashboard3cGraphData(1, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
    }

    if (SelectedValue[0].mainModuleName == "Contact") {
      this.SelectedCCC = SelectedValue[0].orgModuleName;
      if (this.SelectedWMY == "Week") {
        this.WMY = "Week";
        this.GetDashboard3cGraphData(2, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
      if (this.SelectedWMY == "Month") {
        this.WMY = "Month";
        this.GetDashboard3cGraphData(2, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
      if (this.SelectedWMY == "Year") {
        this.WMY = "Year";
        this.GetDashboard3cGraphData(2, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
    }

    if (SelectedValue[0].mainModuleName == "Company") {
      this.SelectedCCC = SelectedValue[0].orgModuleName;
      if (this.SelectedWMY == "Week") {
        this.WMY = "Week";
        this.GetDashboard3cGraphData(3, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
      if (this.SelectedWMY == "Month") {
        this.WMY = "Month";
        this.GetDashboard3cGraphData(3, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
      if (this.SelectedWMY == "Year") {
        this.WMY = "Year";
        this.GetDashboard3cGraphData(3, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
      }
    }

  }


  CCCOptionSelectWMY(event) {
    var SelectedValue = this.CCCList.filter(x => x.orgModuleName == this.SelectedCCC);
    if (event.value == "Week") {
      var type = 0;
      if (SelectedValue[0].mainModuleName == "Core") {
        type = 1;
      }
      if (SelectedValue[0].mainModuleName == "Contact") {
        type = 2;
      }
      if (SelectedValue[0].mainModuleName == "Company") {
        type = 3;
      }
      this.SelectedWMY = "Week";
      this.WMY = "Week";
      this.GetDashboard3cGraphData(type, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
    }

    if (event.value == "Month") {
      var type = 0;
      if (SelectedValue[0].mainModuleName == "Core") {
        type = 1;
      }
      if (SelectedValue[0].mainModuleName == "Contact") {
        type = 2;
      }
      if (SelectedValue[0].mainModuleName == "Company") {
        type = 3;
      }
      this.SelectedWMY = "Month";
      this.WMY = "Month";
      this.GetDashboard3cGraphData(type, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
    }

    if (event.value == "Year") {
      var type = 0;
      if (SelectedValue[0].mainModuleName == "Core") {
        type = 1;
      }
      if (SelectedValue[0].mainModuleName == "Contact") {
        type = 2;
      }
      if (SelectedValue[0].mainModuleName == "Company") {
        type = 3;
      }
      this.SelectedWMY = "Year";
      this.WMY = "Year";
      this.GetDashboard3cGraphData(type, this.WMY); // 1-Core ,2-Contact ,3-Company (Week,Month,Year)
    }
  }

  CCCMonth() {
    const now = new Date();
    var date = new Date(now.getTime() + (now.getTimezoneOffset() * 60000));

    // var date =new Date();
    var d = new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    d.setDate(d.getDate() - 27);
    let lastDay = this.datepipe.transform(date, 'yyyy-MM-dd');
    let firstDay = this.datepipe.transform(d, 'yyyy-MM-dd');

    // const first = new Date();
    // var dayfirst= new Date(first.getTime() + (first.getTimezoneOffset() * 60000));
    // const last = new Date(lastDay);
    // var daylast= new Date(last.getTime() + (last.getTimezoneOffset() * 60000));

    //  var date = this.getNowUTC();
    //  var d = this.getNowUTC();
    //  date.setDate(date.getDate()-27);
    // let lastDay =this.datepipe.transform(d, 'yyyy-MM-dd');
    // let firstDay =this.datepipe.transform(date, 'yyyy-MM-dd');

    // 1st Week Date
    this.FirstWeekFirstDate = this.datepipe.transform(d, 'yyyy-MM-dd')
    const now1 = new Date(this.FirstWeekFirstDate);
    var d1W = new Date(now1.getTime() + (now1.getTimezoneOffset() * 60000));
    // var d1W = new Date(this.FirstWeekFirstDate);
    d1W.setDate(d1W.getDate() + 6);
    this.FirstWeekLastDate = this.datepipe.transform(d1W, 'yyyy-MM-dd');

    // 2nd Week Date
    const now2 = new Date(this.FirstWeekLastDate);
    var D21WS = new Date(now2.getTime() + (now2.getTimezoneOffset() * 60000));
    //var D21WS = new Date(this.FirstWeekLastDate);
    D21WS.setDate(d1W.getDate() + 1);
    this.SecondWeekFirstDate = this.datepipe.transform(D21WS, 'yyyy-MM-dd');
    // var D2WS = new Date(this.SecondWeekFirstDate);
    const now3 = new Date(this.SecondWeekFirstDate);
    var D2WS = new Date(now3.getTime() + (now3.getTimezoneOffset() * 60000));
    D2WS.setDate(D2WS.getDate() + 6);
    this.SecondWeekLastDate = this.datepipe.transform(D2WS, 'yyyy-MM-dd');

    // 3rd Week Date
    const now4 = new Date(this.SecondWeekLastDate);
    var D31WS = new Date(now4.getTime() + (now4.getTimezoneOffset() * 60000));
    // var D31WS = new Date(this.SecondWeekLastDate);
    D31WS.setDate(D31WS.getDate() + 1);
    this.ThirdWeekFirstDate = this.datepipe.transform(D31WS, 'yyyy-MM-dd');
    // var D3WS = new Date(this.ThirdWeekFirstDate);
    const now5 = new Date(this.ThirdWeekFirstDate);
    var D3WS = new Date(now5.getTime() + (now5.getTimezoneOffset() * 60000));
    D3WS.setDate(D3WS.getDate() + 6);
    this.ThirdWeekLastDate = this.datepipe.transform(D3WS, 'yyyy-MM-dd');

    // 4th Week Date
    const now6 = new Date(this.ThirdWeekLastDate);
    var D41WS = new Date(now6.getTime() + (now6.getTimezoneOffset() * 60000));
    //var D41WS = new Date(this.ThirdWeekLastDate);
    D41WS.setDate(D41WS.getDate() + 1);
    this.FourthWeekFirstDate = this.datepipe.transform(D41WS, 'yyyy-MM-dd');
    // var D4WS = new Date(this.FourthWeekFirstDate);
    const now7 = new Date(this.FourthWeekFirstDate);
    var D4WS = new Date(now7.getTime() + (now7.getTimezoneOffset() * 60000));
    D4WS.setDate(D4WS.getDate() + 6);
    this.FourthWeekLastDate = this.datepipe.transform(D4WS, 'yyyy-MM-dd');
  }

  CCCYear() {
    var d = new Date();
    var currentYear = d.getFullYear();
    this.FirstMonthFirstDate = this.datepipe.transform(new Date(currentYear, 0, 1), 'yyyy-MM-dd');
    this.FirstMonthLastDate = this.datepipe.transform(new Date(currentYear, 0 + 1, 0), 'yyyy-MM-dd');

    this.SecondMonthFirstDate = this.datepipe.transform(new Date(currentYear, 1, 1), 'yyyy-MM-dd');
    this.SecondMonthLastDate = this.datepipe.transform(new Date(currentYear, 1 + 1, 0), 'yyyy-MM-dd');

    this.ThirdMonthFirstDate = this.datepipe.transform(new Date(currentYear, 2, 1), 'yyyy-MM-dd');
    this.ThirdMonthLastDate = this.datepipe.transform(new Date(currentYear, 2 + 1, 0), 'yyyy-MM-dd');

    this.FourthMonthFirstDate = this.datepipe.transform(new Date(currentYear, 3, 1), 'yyyy-MM-dd');
    this.FourthMonthLastDate = this.datepipe.transform(new Date(currentYear, 3 + 1, 0), 'yyyy-MM-dd');

    this.FifthMonthFirstDate = this.datepipe.transform(new Date(currentYear, 4, 1), 'yyyy-MM-dd');
    this.FifthMonthLastDate = this.datepipe.transform(new Date(currentYear, 4 + 1, 0), 'yyyy-MM-dd');

    this.SixthMonthFirstDate = this.datepipe.transform(new Date(currentYear, 5, 1), 'yyyy-MM-dd');
    this.SixthMonthLastDate = this.datepipe.transform(new Date(currentYear, 5 + 1, 0), 'yyyy-MM-dd');

    this.SeventhMonthFirstDate = this.datepipe.transform(new Date(currentYear, 6, 1), 'yyyy-MM-dd');
    this.SeventhMonthLastDate = this.datepipe.transform(new Date(currentYear, 6 + 1, 0), 'yyyy-MM-dd');

    this.EightMonthFirstDate = this.datepipe.transform(new Date(currentYear, 7, 1), 'yyyy-MM-dd');
    this.EightMonthLastDate = this.datepipe.transform(new Date(currentYear, 7 + 1, 0), 'yyyy-MM-dd');

    this.NinthMonthFirstDate = this.datepipe.transform(new Date(currentYear, 8, 1), 'yyyy-MM-dd');
    this.NinthMonthLastDate = this.datepipe.transform(new Date(currentYear, 8 + 1, 0), 'yyyy-MM-dd');

    this.TenthMonthFirstDate = this.datepipe.transform(new Date(currentYear, 9, 1), 'yyyy-MM-dd');
    this.TenthMonthLastDate = this.datepipe.transform(new Date(currentYear, 9 + 1, 0), 'yyyy-MM-dd');

    this.ElevenMonthFirstDate = this.datepipe.transform(new Date(currentYear, 10, 1), 'yyyy-MM-dd');
    this.ElevenMonthLastDate = this.datepipe.transform(new Date(currentYear, 10 + 1, 0), 'yyyy-MM-dd');

    this.TwelveMonthFirstDate = this.datepipe.transform(new Date(currentYear, 11, 1), 'yyyy-MM-dd');
    this.TwelveMonthLastDate = this.datepipe.transform(new Date(currentYear, 11 + 1, 0), 'yyyy-MM-dd');
  }

  // For Signature Graph (donut pie chart)

  sentStatsList: any = [] = [];
  inboxStatsList: any = [] = [];
  sentStatsTotal: number = 0;
  inboxStatsTotal: number = 0;
  RecordCountSign: number[] = [];
  showSignaturegraph: boolean = false;

  GetDashboardSignatureGraphData(firstDay, lastDay) {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      email: sessionStorage.getItem('email'),
      officeID: this.myOfficeID,
      startDate: firstDay,
      endDate: lastDay,
      type: 1 // 1-Core ,2-Contact ,3-Company
    }
    this.formsService.getDashboardSignatureGraphData(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.showSignaturegraph = true;
        this.inboxStatsList = [];
        this.sentStatsList = [];
        this.RecordCountSign = [];
        this.inboxStatsTotal = 0;
        this.sentStatsTotal = 0;
        this.inboxStatsList = response.data.inboxStats;
        this.sentStatsList = response.data.sentStats;

        if (this.sentStatsList.length > 0) {
          var sentlist = response.data.sentStats;
          var Total = sentlist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.sentStatsTotal = Total;
          this.RecordCountSign.push(this.sentStatsTotal);
        } else {
          this.RecordCountSign.push(0);
        }

        if (this.inboxStatsList.length > 0) {
          var inboxlist = response.data.inboxStats;
          var Total = inboxlist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.inboxStatsTotal = Total;
          this.RecordCountSign.push(this.inboxStatsTotal);
        } else {
          this.RecordCountSign.push(0);
        }

        if (this.inboxStatsList.length > 0 || this.sentStatsList.length > 0) {
          this.chartOptionspie = {
            seriespie: this.RecordCountSign,
            dataLabels: {
              formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]
              },
            },
            // seriespie: [0,0,1],
            chart: {
              type: "donut",
              width: 283,
              height: 160,
            },
            legend: {
              position: 'bottom',
            },
            colors: ['#BCE0FD', '#2699FB'],
            labels: ["Sent", "Inbox"],

          };
        } else {
          this.chartOptionspie = {
            dataLabels: {
              formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]
              },
            },
            seriespie: [0],
            chart: {
              type: "donut",
              width: 283,
              height: 160,
            },
            legend: {
              position: 'bottom',
            },
            colors: ['#F6F6F6'],
            labels: ['No Record'],

          };
        }
      }
      else {
        this.showSignaturegraph = true;
        this.chartOptionspie = {
          dataLabels: {
            formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
            },
          },
          seriespie: [0],
          chart: {
            type: "donut",
            width: 283,
            height: 160,
          },
          legend: {
            position: 'bottom',
          },
          colors: ['#F6F6F6'],
          labels: ['No Record'],
        };
      }
    });
  }

  SignatureOptionSelect(event) {
    if (event.value == "Day") {
      var date = this.getNowUTC();
      //var date = new Date();
      var firstDay = this.datepipe.transform(date, 'yyyy-MM-dd');
      var lastDay = this.datepipe.transform(date, 'yyyy-MM-dd');
      this.GetDashboardSignatureGraphData(firstDay, lastDay);
    }
    if (event.value == "Week") {
      // var date =new Date();
      // var d = new Date();
      // d.setDate(d.getDate()-6);
      // var lastDay =this.datepipe.transform(date, 'yyyy-MM-dd');
      // var firstDay =this.datepipe.transform(d, 'yyyy-MM-dd');     
      var date = this.getNowUTC();
      var d = this.getNowUTC();
      date.setDate(date.getDate() - 6);
      let lastDay = this.datepipe.transform(d, 'yyyy-MM-dd');
      let firstDay = this.datepipe.transform(date, 'yyyy-MM-dd');
      this.GetDashboardSignatureGraphData(firstDay, lastDay);
    }
    if (event.value == "Month") {
      var date = new Date();
      var first = new Date(date.getFullYear(), date.getMonth(), 1);
      var firstDay = this.datepipe.transform(first, 'yyyy-MM-dd');

      var last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      var lastDay = this.datepipe.transform(last, 'yyyy-MM-dd');

      this.GetDashboardSignatureGraphData(firstDay, lastDay);
    }
  }



  // For added this week (Core/Contact/Company/Forms/File Manager/Notes)

  coreList: any[] = [];
  contactList: any[] = [];
  companyList: any[] = [];
  formsList: any[] = [];
  fileManagerList: any[] = [];
  noteList: any[] = [];

  coreCount: number = 0;
  contactCount: number = 0;
  companyCount: number = 0;
  formsCount: number = 0;
  fileManagerCount: number = 0;
  notesCount: number = 0;

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  getDashboardStats() {
    var date = this.getNowUTC();
    var d = this.getNowUTC();
    date.setDate(date.getDate() - 6);
    let endDate = this.datepipe.transform(d, 'yyyy-MM-dd');
    let startDate = this.datepipe.transform(date, 'yyyy-MM-dd');

    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      startDate: startDate,
      endDate: endDate,
    }
    this.formsService.getDashboardStats(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.menuModulesList;
        this.coreList = response.data.cores;
        this.contactList = response.data.contacts;
        this.companyList = response.data.companies;
        this.formsList = response.data.projects;
        this.fileManagerList = response.data.files;
        this.noteList = response.data.notes;

        if (this.coreList.length > 0) {
          var corelist = response.data.cores;
          var Total = corelist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.coreCount = Total;
        } else {
          this.coreCount = 0;
        }
        if (this.contactList.length > 0) {
          var contactlist = response.data.contacts;
          var Total = contactlist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.contactCount = Total;
        } else {
          this.contactCount = 0;
        }
        if (this.companyList.length > 0) {
          var companylist = response.data.companies;
          var Total = companylist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.companyCount = Total;
        } else {
          this.companyCount = 0;
        }
        if (this.formsList.length > 0) {
          var formlist = response.data.projects;
          var Total = formlist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.formsCount = Total;
        } else {
          this.formsCount = 0;
        }
        if (this.fileManagerList.length > 0) {
          var filemanagerlist = response.data.files;
          var Total = filemanagerlist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.fileManagerCount = Total;
        } else {
          this.fileManagerCount = 0;
        }
        if (this.noteList != null) {
          var noteslist = response.data.notes;
          var Total = noteslist.reduce(function (prev, cur) {
            return prev + cur.count;
          }, 0);
          this.notesCount = Total;
        } else {
          this.notesCount = 0;
        }
        var checkCore = [];
        var checkContact = [];
        var checkCompany = [];
        var checkCompany = [];
        var checkForms = [];
        var checkFileManager = [];
        checkCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
        if (checkCore.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Core").note = +this.coreCount + " added this week";
        }
        checkContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
        if (checkContact.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Contact").note = +this.contactCount + " added this week";
        }
        checkCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
        if (checkCompany.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Company").note = +this.companyCount + " added this week";
        }
        checkForms = this.menuModulesList.filter(x => x.mainModuleName == 'Forms');
        if (checkForms.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Forms").note = +this.formsCount + " added this week";
        }
        checkFileManager = this.menuModulesList.filter(x => x.mainModuleName == 'File Manager');

        if (checkFileManager.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "File Manager").note = +this.fileManagerCount + " added this week";
        }

        // var checkNote=[];
        // checkNote= this.menuModulesList.filter((item) => item.mainModuleName == "Notes");
        // if(checkNote.length>0){
        //   this.menuModulesList.find((item) => item.mainModuleName == "Notes").note = +this.notesCount+" added this week";
        // }     
      }
      else {
        var checkCore = [];
        var checkContact = [];
        var checkCompany = [];
        var checkCompany = [];
        var checkForms = [];
        var checkFileManager = [];
        checkCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
        if (checkCore.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Core").note = +this.coreCount + " added this week";
        }
        checkContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
        if (checkContact.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Contact").note = +this.contactCount + " added this week";
        }
        checkCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
        if (checkCompany.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Company").note = +this.companyCount + " added this week";
        }
        checkForms = this.menuModulesList.filter(x => x.mainModuleName == 'Forms');
        if (checkForms.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "Forms").note = +this.formsCount + " added this week";
        }
        checkFileManager = this.menuModulesList.filter(x => x.mainModuleName == 'File Manager');
        if (checkFileManager.length > 0) {
          this.menuModulesList.find((item) => item.mainModuleName == "File Manager").note = +this.fileManagerCount + " added this week";
        }

        //this.menuModulesList.find((item) => item.mainModuleName == "Notes").note = +this.notesCount+" added this week";
        // this.menuModulesList.find((item) => item.mainModuleName == "Core").note = +this.coreCount+" added this week";
        // this.menuModulesList.find((item) => item.mainModuleName == "Contact").note = +this.contactCount+" added this week";
        // this.menuModulesList.find((item) => item.mainModuleName == "Company").note = +this.companyCount+" added this week";
        // this.menuModulesList.find((item) => item.mainModuleName == "Forms").note = +this.formsCount+" added this week";
        // this.menuModulesList.find((item) => item.mainModuleName == "File Manager").note = +this.fileManagerCount+" added this week";
        // this.menuModulesList.find((item) => item.mainModuleName == "Notes").note = +this.notesCount+" added this week";
      }
    });
  }


  // For Forms Inbox/Sent/Draft
  paginatorTotalLength: any;

  pageModelData = {
    pageIndex: 0,
    pageSize: 100,
    searchValue: '',
  };

  pageIndex: any;
  pageSize: any;
  inboxProjectsList: any[] = [];
  sentProjectsList: any[] = [];
  draftProjectsList: any[] = [];
  noRecordFoundInbox: boolean = false;
  noRecordFoundSent: boolean = false;
  noRecordFounddraft: boolean = false;
  ShowInbox: boolean = false;
  ShowSent: boolean = false;
  ShowDraft: boolean = false;


  getInboxProjects(pageData: any) {
    this.ShowInbox = true;
    var ReqModel = {
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      searchKey: this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formsService.getInboxProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.inboxProjectsList = response.data.sentOrInboxListModelList;
        this.inboxProjectsList = this.inboxProjectsList.filter((m) => m.status == 0 || m.status==2);
        this.inboxProjectsList.forEach(e => {
          e.signHref = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + e.signingToken
        });
        if (this.inboxProjectsList.length > 0) {
          this.noRecordFoundInbox = false;
        } else {
          this.noRecordFoundInbox = true;
        }
      }
      else {
      }
    });
  }

  getSentProjects(pageData: any) {
    var ReqModel = {
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      searchKey: this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formsService.getSentProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.sentProjectsList = response.data.sentOrInboxListModelList;
        if (this.sentProjectsList.length > 0) {
          this.noRecordFoundSent = false;
        } else {
          this.noRecordFoundSent = true;
        }
      } else {
      }
    });
  }

  getDraftedProjects(pageData: any) {
    var ReqModel = {
      projectStatus: 1,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      searchKey: this.pageModelData.searchValue,
      pageIndex: pageData.pageIndex,
      pageSize: pageData.pageSize,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formsService.getDraftedProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.draftProjectsList = response.data.projects;
        if (this.draftProjectsList.length > 0) {
          this.noRecordFounddraft = false;
        } else {
          this.noRecordFounddraft = true;
        }
      } else {
      }
    });
  }

  OpenProjectDeatils(project) {
    this._dataSharingService.SendCurrentFormContact(null);
    sessionStorage.setItem('ProjectName', project.projectName);
    sessionStorage.setItem('projectID', project.projectID);
    sessionStorage.setItem('stepCompleted', project.stepCompleted);
    sessionStorage.setItem('type', '1');
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    sessionStorage.setItem('isSharedWithMeForm', 'false');
    if (project.stepCompleted == 0) {
      this.router.navigate(['/esignature/first']);
    }
    else if (project.stepCompleted == 1) {
      this.router.navigate(['/esignature/second']);
    }
    else if (project.stepCompleted == 2) {
      this.router.navigate(['/esignature/third']);
    }
    else if (project.stepCompleted == 3 || project.stepCompleted == 4) {
      this.router.navigate(['/esignature/four']);
    }
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }

  OpenTablarDeatils(project) {
    if (project.token != null) {
      let formSigningLink = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + project.token;
      window.open(formSigningLink, "_blank");
    }
  }

  OpenDetailsSent(sent) {
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.SendCurrentFormContact(null);
    this._dataSharingService.sendSentSelectedDetail(sent);
    this.router.navigate(['/esignature/sent']);
  }

  TypeSelection(event) {
    this.currentSignatureView = event;
    if (event == "Inbox") {
      this.ShowInbox = true;
      this.ShowSent = false;
      this.ShowDraft = false;
      this.getInboxProjects(this.pageModelData);
    }
    if (event == "Sent") {
      this.ShowInbox = false;
      this.ShowSent = true;
      this.ShowDraft = false;
      this.getSentProjects(this.pageModelData);
    }
    if (event == "Draft") {
      this.ShowInbox = false;
      this.ShowSent = false;
      this.ShowDraft = true;
      this.getDraftedProjects(this.pageModelData);
    }
  }


  // Notes  //
  PersonalChecked: boolean = true;
  GlobalChecked: boolean = false;
  PortalChecked: boolean = false;
  addNotesForm: FormGroup;
  addQuickLinkForm: FormGroup;
  selectedColor: string = "";
  showColorDrp: boolean = true;
  responseHolder: any;
  noteLevel: number = 2;
  noteLevelType: number = 0;
  NotesList: any[] = [];
  showNotesList: boolean = true;
  noteType: string = "0";
  notes: string = "";
  color: string = "";
  quickLinkColor: string = "";
  noteID: number = 0;
  maxChars = 350;
  addnotes: number = 0;

  addNotes(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.noteID = 0;
    this.addnotes = 0;
    this.selectedColor = "#F5D428";
    this.noteLevel = 2;
    this.PersonalChecked = true;
    this.GlobalChecked = false;
    this.PortalChecked = false;
    this.showColorDrp = true;
    this.savebuttonshow = false;
    this.addNotesForm.patchValue({
      color: "#F5D428"
    });
  }

  updateNotes(templateRef: TemplateRef<any>, notes) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.notes = notes.note;
    this.notes = notes.note.replace(/<\/?a[^>]*>/g, "");
    this.color = notes.color;
    this.selectedColor = notes.color;
    this.noteID = notes.noteID;
    this.noteLevel = notes.noteLevelID;
    this.addnotes = notes.note.length;
    this.savebuttonshow = false;
    this.addNotesForm.patchValue({
      color: this.color
    });
  }

  // add/update notes // 
  AddNotes(formValues) {
    var ReqModel = {
      noteID: this.noteID,
      noteLevelID: this.noteLevel, // 1- Global, 2- Personal ,3-Portal
      note: formValues.notes,
      color: formValues.color,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.spinner = true;
    this.savebuttonshow = true;
    this.formsService.addNote(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner = false;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.GetNotes(Number(this.noteType));
          this.getDashboardStats();
          if (this.noteID == 0) {
            this.toastr.success('Note added successfully.', '', {
              timeOut: 3000,
            });
          }
          if (this.noteID > 0) {
            this.toastr.success('Note update successfully.', '', {
              timeOut: 3000,
            });
          }
          this.close();
        }
      } else {
        this.spinner = false;
      }
    });
  }

  GetNotes(noteLevelType) {
    var ReqModel = {
      noteLevel: noteLevelType, //--0 ALL , 1- Global, 2- Personal
      pageIndex: 0,
      pageSize: 500,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formsService.getNotes(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.NotesList = this.responseHolder.data;
          if (this.NotesList != null) {
            this.NotesList.map((res) => {
              if (res.createdByFirstName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByLastName);
              }
              if (res.note != null) {
                res.note = this.addAnchorsToText(res.note);
              }
              return res;
            });
            this.showNotesList = true;
          } else {
            this.NotesList = [];
            this.showNotesList = false;
          }
        } else {
          this.NotesList = [];
          this.showNotesList = false;
        }
      } else {
        this.NotesList = [];
        this.showNotesList = false;
      }
    });
  }

  selectNotes(evt) {
    if (evt.value == "1") {
      this.noteLevel = 1;
      this.PersonalChecked = false;
      this.GlobalChecked = true;
      this.showColorDrp = false;
      this.PortalChecked = false;
      this.selectedColor = "";
      this.addNotesForm.patchValue({
        color: " "
      });
    }
    if (evt.value == "2") {
      this.noteLevel = 2;
      this.PersonalChecked = true;
      this.GlobalChecked = false;
      this.showColorDrp = true;
      this.PortalChecked = false;
      // this.addNotesForm.controls.color.setValue(null);  
      this.addNotesForm.patchValue({
        color: "#F5D428"
      });
    }
    if (evt.value == "3") {
      this.noteLevel = 3;
      this.PersonalChecked = false;
      this.GlobalChecked = false;
      this.PortalChecked = true;
      this.showColorDrp = true;
      this.addNotesForm.patchValue({
        color: "#F5D428"
      });
      //this.selectedColor="";
      //   this.addNotesForm.patchValue({
      //    color: " "
      //  });
    }
  }

  onSelectNoteFilter(event) {
    this.noteType = event.value;
    this.GetNotes(Number(event.value)); // ---0 ALL , 1- Global, 2- Personal   
  }

  // Delete Note
  DeleteNotes(notes) {
    const message = `Are you sure you want to delete this note?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          if (notes !== undefined) {
            var ReqModel = {
              noteID: notes.noteID,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              officeID: this.myOfficeID,
              OfficeIDList: this.OfficeIDList
            }
            this.formsService.deleteNotes(ReqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                  this.GetNotes(Number(this.noteType));
                  this.getDashboardStats();
                  this.toastr.success('Note delete successfully.', '', {
                    timeOut: 3000,
                  });
                } else {

                }
              } else {

              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  close() {
    this.savebuttonshow = false;
    this.noteID = 0;
    this.selectedColor = "";
    this.addnotes = 0;
    this.addNotesForm.reset();
    this.dialog.closeAll();
  }

  onAddNoteCharCheck(textValue: string): void {
    if (textValue != null || textValue != undefined) {
      this.addnotes = textValue.length;
    }
  }

  insertIntoString(str: string, pos: number, fragment: string) {
    return str.slice(0, pos) + fragment + str.slice(pos + 1, str.length);
  }

  addAnchorsToText(text) {
    // https://www.regextester.com/94502
    const regexp = /((?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+%,;=.]+)/igm;
    const map = {};
    return text.replace(regexp, (_, match, __, pos) => {
      // This map helps us to keep a count of the duplicate matches.
      if (map[match] !== undefined) map[match]++;
      else map[match] = 0;

      // These next few lines handle duplicates. We want to handle cases like this: 
      // <a href="myurl.com">foo</a> bar baz myurl.com.
      let testString = text.replace(new RegExp(escapeRegExp(match), 'ig'), '$');
      let newPos = pos - map[match] * (match.length - 1);
      testString = this.insertIntoString(testString, newPos, match);

      // Detect if the url was found here -> <a href="#here#">
      const hrefRegex = new RegExp(`<a[^>]*href="${escapeRegExp(match)}"[^>]*>[^<]*<\/a>`, 'ig');
      const isHref = hrefRegex.test(testString);

      // Detect if the url was found here -> <a href="...">#here#</a>
      const anchoredRegex = new RegExp(`<a[^>]*>[^<]*${escapeRegExp(match)}[^<]*<\/a>`, 'ig');
      const isAnchored = anchoredRegex.test(testString);

      // If the url is found in href or anchor, then do nothing with it, it needs no further treatment.
      if (isAnchored || isHref) return match;
      const hasProtocol = /^http[s]?:\/\/.*$/igm.test(match);
      return `<a href="${hasProtocol ? '' : 'http://'}${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
    });
    function escapeRegExp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
  }

  // ==== Recently Created === //
  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;
  RecentlyCreatedCCCList: any = [] = [];
  RecentlySelectedType: string = "";
  noRecordFoundCCC: boolean = false;

  getRecentlyCCCList(folderId, type) {
    this.RecentlyCreatedCCCList = [];
    var SelectedType = this.CCCList.filter(x => x.orgModuleName == type);
    var ReqModel = {
      FolderId: folderId,
      PageIndex: 0,
      PageSize: 10,
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      RoleIDList: sessionStorage.getItem('roleIDList').split(','),
      OfficeIDList: this.OfficeIDList,
      officeID: this.myOfficeID
    }
    this.formsService.getCCCList(ReqModel, SelectedType[0].mainModuleName).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          var SelectedValue = this.CCCList.filter(x => x.orgModuleName == type);
          if (SelectedValue[0].mainModuleName == "Core") {
            this.RecentlyCreatedCCCList = response.data.transactions;
            sessionStorage.setItem('coreList', JSON.stringify(response.data.transactions));
          }
          if (SelectedValue[0].mainModuleName == "Contact") {
            this.RecentlyCreatedCCCList = response.data.contacts;
            sessionStorage.setItem('contactList', JSON.stringify(response.data.contacts));
          }
          if (SelectedValue[0].mainModuleName == "Company") {
            this.RecentlyCreatedCCCList = response.data.companies;
            sessionStorage.setItem('companyList', JSON.stringify(response.data.companies));
          }
          if (this.RecentlyCreatedCCCList != null) {
            this.RecentlyCreatedCCCList = this.RecentlyCreatedCCCList.slice(0, 5)
          }

          if (this.RecentlyCreatedCCCList != null && this.RecentlyCreatedCCCList.length > 0) {
            this.noRecordFoundCCC = false;
            this.RecentlyCreatedCCCList.map(e => {
              if (e.fields.length > 0) {
                e.fields.map(e1 => {
                  if (e1.fieldName == "Name") {
                    e.fieldName = e1.fieldName;
                    e.fieldValueName = e1.fieldValue;
                    e.type = type;
                  }
                  if (e1.fieldName == "Type") {
                    e.fieldType = e1.fieldName;
                    e.fieldValueType = e1.fieldValue;
                    e.type = type;
                    e.subFolderID = e1.subFolderID
                  }
                  return e1;
                });
              }
            });
          } else {
            this.noRecordFoundCCC = true;
          }
        } else {
          this.noRecordFoundCCC = true;
        }
      } else {
        this.noRecordFoundCCC = true;
      }
    });
  }

  RecentlyCreatedSelect(event, moduleName) {
    this.currentCoreType = event;
    var SelectedValue = this.CCCList.filter(x => x.mainModuleName == moduleName);
    if (SelectedValue[0].mainModuleName == "Core") {
      this.currentCoreType = "Core";
      this.RecentlySelectedType = event;
      this.getRecentlyCCCList(this.CorefolderID, SelectedValue[0].orgModuleName);
    }
    if (SelectedValue[0].mainModuleName == "Contact") {
      this.currentCoreType = "Contact";
      this.RecentlySelectedType = event;
      this.getRecentlyCCCList(this.ContactfolderID, SelectedValue[0].orgModuleName);
    }
    if (SelectedValue[0].mainModuleName == "Company") {
      this.currentCoreType = "Company";
      this.RecentlySelectedType = event;
      this.getRecentlyCCCList(this.CompanyfolderID, SelectedValue[0].orgModuleName);
    }
  }

  getShortName(fullName) {
    var name = fullName;
    if (name != null || name != undefined) {
      return fullName.split(' ').map(n => n[0]).join('');
    } else {
      return '';
    }
  }

  ViewProfile(actionObj: any) {
    var id;
    var SelectedValue = this.CCCList.filter(x => x.orgModuleName == actionObj.type);
    if (SelectedValue[0].mainModuleName == "Core") {
      id = actionObj.coreID;
    }
    if (SelectedValue[0].mainModuleName == "Contact") {
      id = actionObj.contactID;
    }
    if (SelectedValue[0].mainModuleName == "Company") {
      id = actionObj.companyID;
    }
    if (actionObj.subFolderID == null || actionObj.subFolderID == undefined) {
      actionObj.subFolderID = 0;
    }
    sessionStorage.setItem('transactionID', id);
    sessionStorage.setItem('TypeID', actionObj.subFolderID);
    sessionStorage.setItem('moduleName', SelectedValue[0].mainModuleName);
    if (SelectedValue[0].mainModuleName == 'Core') {
      this.router.navigate(['/core/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCore(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
      //this._dataSharingService.sendSelectedCoreUser(tagId);
    }
    if (SelectedValue[0].mainModuleName == 'Contact') {
      this.router.navigate(['/contact/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromContact(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
      this._dataSharingService.sendNextPreviousForTouchesFromContact(false);
      // this._dataSharingService.sendSelectedContactUser(tagId);
    }

    if (SelectedValue[0].mainModuleName == 'Company') {
      this.router.navigate(['/company/documents'], {});
      this._dataSharingService.sendNextPreviousDocumentFromCompany(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCompany(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCompany(false);
      // this._dataSharingService.sendSelectedCompanyUser(tagId);
    }

  }

  Viewall(actionObj: any) {
    var SelectedValue = this.CCCList.filter(x => x.orgModuleName == actionObj.type);
    if (SelectedValue[0].mainModuleName == "Core") {
      var show = sessionStorage.getItem('coreshowkanban');
      if (show == 'true') {
        this.router.navigate(['/core/kanbanview'], {});
      } else {
        this.router.navigate(['/core/listing']);
      }
      //this.router.navigate(['/core/listing']);
    }
    if (SelectedValue[0].mainModuleName == "Contact") {
      var show = sessionStorage.getItem('contactshowkanban');
      if (show == 'true') {
        this.router.navigate(['/contact/kanbanview'], {});
      } else {
        this.router.navigate(['/contact/listing']);
      }
      //this.router.navigate(['/contact/listing']);
    }
    if (SelectedValue[0].mainModuleName == "Company") {
      var show = sessionStorage.getItem('companyshowkanban');
      if (show == 'true') {
        this.router.navigate(['/company/kanbanview'], {});
      } else {
        this.router.navigate(['/company/listing']);
      }
      // this.router.navigate(['/company/listing']);
    }
  }




  //  links = [
  //   {
  //     routelink:'/core/listing',
  //     name:'Core',
  //     note:'0 added this week'
  //   },
  //   {
  //     routelink:'/contact/listing',
  //     name:'Contact',
  //     note:'0 added this week'
  //   },
  //   {
  //     routelink:'/company/listing',
  //     name:'Company',
  //     note:'0 added this week'
  //   },
  //   {
  //     routelink:'/esignature',
  //     name:'Forms',
  //     note:'0 created in this week'
  //   },
  //   {
  //     routelink:'/filemanager',
  //     name:'File Manager',
  //     note:'0 added this week'
  //   },
  //   {
  //     routelink:'/notes',
  //     name:'Notes',
  //     note:'0 added this week'
  //   }
  //  ]

  col = [
    {
      colname: '#F5D428'
    },
    {
      colname: '#6FC040'
    },
    {
      colname: '#52A7F9'
    },
    {
      colname: '#EF8F1E'
    },
    {
      colname: '#EC5C58'
    },
    {
      colname: '#B36AE2'
    },
  ]

  coreGraphView = false;
  coreListView = true;

  coreSignatureGraphView = false;
  coreSignatureListView = true;

  showGraphView() {
    this.coreGraphView = true;
    this.coreListView = false;
  }

  showListView() {
    this.coreListView = true;
    this.coreGraphView = false;
  }

  showSignatureGraphView() {
    this.coreSignatureGraphView = true;
    this.coreSignatureListView = false;
  }

  showSignatureListView() {
    this.coreSignatureListView = true;
    this.coreSignatureGraphView = false;
  }



  getTaskList(type: string) {
    this.currentType = type
    this.isOverDue = false;

    if (type == 'Today') {
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }

    else if (type == 'Tomorrow') {
      this.dateFrom = moment().add(1, 'day').utc().format('YYYY-M-D');
      this.dateTo = moment().add(1, 'day').utc().format('YYYY-M-D');
    }

    else if (type == 'Overdue') {
      this.isOverDue = true;
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }
    this.pageIndex = 1;
    this.pageSize = 30;
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      IsFilterApply: true,
      "filter": {
        IsAssignedToMe: false,
        IsAssignedToMyRole: false,
        IsCreatedByMe: false,
        IsAllTask: true,
        "title": "",
        "description": "",
        "attachedTitle": "",
        "taskListID": 0,
        TaskListFolderID: 0,
        "createdOn": {
          "from": null,
          "to": null
        },
        "assignedOn": {
          "from": null,
          "to": null
        },
        "assignees": [
          0
        ],
        "Priority": [],
        "byDate": {
          "from": this.dateFrom,
          "to": this.dateTo
        },
        isOverDue: this.isOverDue,
        "dueDate": true,
        "status": 0,
        "attachmentType": 0
      },
      "isArchived": false,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    // var ReqModel = {
    //   "paging": {
    //     "pageSize":  this.pageSize,//pageData.pageSize,
    //     "pageIndex": this.pageIndex  //pageData.pageIndex,
    //   },
    //   IsFilterApply: true,
    //   "filter": {
    //     IsAssignedToMe: true,
    //     "createdOn": {
    //       "from": null,
    //       "to": null
    //     },
    //     "assignedOn": {
    //       "from": null,
    //       "to": null
    //     },
    //     "assignees": [
    //       0
    //     ],
    //     "byDate": {
    //       "from": this.dateFrom,
    //       "to": this.dateTo
    //     },
    //     isOverDue: this.isOverDue,
    //     "dueDate": true,
    //     "status": 0,
    //     "attachmentType": 0
    //   },
    //   "isArchived": false,
    //   taskType: 2, // 0-External, 1-Internal ,2-Both
    //   userID: this.currentUser.UID,
    //   officeID: this.myOfficeID,
    //   organizationID: Number(this.organizationId),
    //   officeIDList: this.OfficeIDList,
    //   databaseID: this.databaseId
    // }  

    this.loaderService.show();

    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          // this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
          this.taskList = response.data.tasks;//.filter(m=>m.isInternal==true);
          this.taskList.forEach(state => {
            if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
              state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
            }
          });

          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }


            })
          }

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  taskStatusColors = ['#8f8f8f', '#fdab3d', '#e2445c', '#00c875', '#db241c']
  taskPriorityColors = ['#8f8f8f', '#fdab3d', '#e2445c', '#00c875', '#db241c']

  getBackground(stat) {
    switch (stat) {
      case 1:
        return this.taskStatusColors[0];

      case 2:
        return this.taskStatusColors[1];

      case 3:
        return this.taskStatusColors[2];

      case 4:
        return this.taskStatusColors[3];

      case 5:
        return this.taskStatusColors[4];

      default:
        return "#000000"

    }

  }

  onTaskListStatusChange($event: any, task: any) {
    let taskStatusWithFilter = {
      taskID: task.taskId,
      status: $event,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: [0],
      databaseID: 0
    }
    this.formsService.UpdateSingleTaskStatus(taskStatusWithFilter).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success("Details updated successfully.");
        } else {
          this.loaderService.hide();
          this.toastr.error("Status updated failed.")
        }
      } else {
        this.loaderService.hide();
        this.toastr.success("Status updated failed.")
      }
    });
  }

  getTaskStatus() {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.loaderService.show();
    this.taskService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;

        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusList = this.responseHolder.data;

          let completedTask = this.taskStatusList.find(m => m.taskStatusConstantName == 'completed');
          if (completedTask !== undefined) {
            this.completedTaskStatusID = completedTask.taskStatusID;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  thirdPartyApplicationList: any = [] = [];

  getThirdPartyApplicationList() {
    this.loaderService.show();
    var ReqModel = {
      isOffice: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.taskService.getThirdPartyApis(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.thirdPartyApplicationList = this.responseHolder.data;
          if (this.thirdPartyApplicationList.length > 0) {
            var Paycheck = [];
            var PointClickCare = [];

            Paycheck = this.thirdPartyApplicationList.filter(x => x.thirdPartyApiName.toLowerCase() == "Paychex".toLowerCase());
            PointClickCare = this.thirdPartyApplicationList.filter(x => x.thirdPartyApiName.toLowerCase() == "PointClickCare".toLowerCase());

            if (Paycheck.length > 0) {
              if (Paycheck[0].apiAuthDetail != null) {
                if (Paycheck[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('Paycheck', 'true');
                }
              }
            }
            if (PointClickCare.length > 0) {
              if (PointClickCare[0].apiAuthDetail != null) {
                if (PointClickCare[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('PointClickCare', 'true');
                }
              }
            }
          }
        }
        else {
          this.thirdPartyApplicationList = [];
        }
      }
      else {
        this.thirdPartyApplicationList = [];
      }
    });
  }

  openform() {
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('type', ("1").toString());
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId', '0');
    sessionStorage.setItem('FolderOpenName', '');
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm', 'false');
    this.router.navigate(['/esignature/first']);
  }

  showAuthenticationType = true;

  OpenFolderSendEmail(templateRef: TemplateRef<any>, taskTemplate: any) {
    this.taskTemplateAfterAddingCore = taskTemplate;
    this.checkedByDefaultEmail = true;
    this.checkedByDefaultCore = false;
    this.TaskListName = taskTemplate.templateName;
    this.name = "";
    this.emailid = "";
    this.addButtonShow = false;
    this.SendEmailList = [];

    this.showSearchCore = false;
    this.selectCoreList = [];

    this.AttachChecked = false;
    this.AssigneeChecked = true;
    this.NotifyChecked = false;
    this.SendEmailLater = false;

    this.taskTemplateID = taskTemplate.id;
    this.GetRelationByTaskTemplateID(this.taskTemplateID);
    if (taskTemplate.taskListFolderID > 0) {
      this.taskListFolderID = taskTemplate.taskListFolderID;
    } else {
      this.taskListFolderID = 0;
    }

    this.showTemplateDetailCheckingDuplicateEmail(taskTemplate.id);
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;

    this.showEmail = false;
    this.showMobile = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.emailid = "";
    this.mobileNo = "";

    this.sendButton = false;

    this.dialog.open(templateRef, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      width: '700px',
      maxHeight: '700px',
    });
  }
  GetRelationByTaskTemplateID(TaskTemplateID: any) {
    var ReqModel = {
      TaskTemplateID: Number(TaskTemplateID),
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.formsService.GetRelationByTaskTemplateID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          this.relationList = response.data;
        }else{
          this.relationList=[];
        }
      }else{
        this.relationList=[];
      }
    });
  }
  showTemplateDetailCheckingDuplicateEmail(templateID) {
    this.loaderService.show();
    this.currentTemplateId = templateID;
    let ReqModel = {
      "taskTemplateID": templateID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": this.myOfficeID,
      "officeIDList": this.OfficeIDList,
      "databaseID": Number(this.databaseId),
    }
    this.taskService.getTaskTemplateEmailLog(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sendForSign = response.data;
        }
      }
    })

  }

  getTokenEmail(value: MatRadioChange) {
    this.showEmail = true;
    this.showMobile = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.emailid = "";
    this.mobileNo = "";

    this.showSearchCore = false;
    this.selectCoreList = [];

  }

  getTokenMobile(value: MatRadioChange) {
    this.showEmail = false;
    this.showMobile = true;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.emailid = "";
    this.mobileNo = "";

    this.showSearchCore = false;
    this.selectCoreList = [];
  }

  getCorePanel(value: MatRadioChange) {
    this.showEmail = false;
    this.showMobile = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.emailid = "";
    this.mobileNo = "";

    this.showSearchCore = true;
    this.selectCoreList = [];
  }

  showTemplateDetail(templateID) {
    this.loaderService.show();
    this.showTaskTempalteDetail = true;
    this.currentTemplateId = templateID;
    let ReqModel = {
      "taskTemplateID": templateID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": this.myOfficeID,
      "officeIDList": this.OfficeIDList,
      "databaseID": Number(this.databaseId),
    }
    this.taskService.getTaskTemplateEmailLog(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sendForSign = response.data;
        }
      }
    })

  }

  AddEmail(e: any) {
    if (this.name == "") {
      this.toastr.warning("Please add name.");
      return;
    }
    if (this.sendForSign.length > 0) {
      var check = [];
      check = this.sendForSign.filter(x => x.email.toLowerCase() == e.target.value.toLowerCase());
      if (check.length > 0) {
        var createdDateTime = new Date((check[0].lastSentDate) + 'Z');

        let lastSenddate = this.datepipe.transform(createdDateTime, 'dd-MM-yyyy');
        let todayDate = this.datepipe.transform(new Date(), 'dd-MM-yyyy');

        if (lastSenddate == todayDate) {
          this.toastr.warning("Tasklist allready sent given email-id with same date.");
          return;
        }
      }
    }

    if (this.SendEmailList.length >= 5) {
      this.toastr.warning("only 5 email are allowed.");
    } else {
      const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let result = emailregex.test(e.target.value);
      if (result) {
        if (!this.SendEmailList.includes(e.target.value.toLowerCase()))
          var obj = {
            emailid: e.target.value.toLowerCase(),
            name: this.name
          }
        this.SendEmailList.push(obj);
        // this.SendEmailList.push(e.target.value.toLowerCase());
        e.target.value = '';
        this.emailid = "";
        this.addButtonShow = false;
        this.name = "";
      } else {
        this.toastr.warning("Please add a valid email.");
        this.addButtonShow = false;
      }
    }
  }

  addEmails() {

    if (this.name == "") {
      this.toastr.warning("Please add name.");
      return;
    }

    if (this.sendForSign.length > 0) {
      var check = [];
      check = this.sendForSign.filter(x => x.email.toLowerCase() == this.emailid.toLowerCase());
      if (check.length > 0) {

        var createdDateTime = new Date((check[0].lastSentDate) + 'Z');

        let lastSenddate = this.datepipe.transform(createdDateTime, 'dd-MM-yyyy');
        let todayDate = this.datepipe.transform(new Date(), 'dd-MM-yyyy');

        if (lastSenddate == todayDate) {
          this.toastr.warning("Tasklist allready sent given email-id with same date.");
          return;
        }
      }
    }


    if (this.SendEmailList.length >= 5) {
      this.toastr.warning("only 5 email are allowed.");
    } else {
      if (!this.SendEmailList.includes(this.emailid.toLowerCase())) {
        var obj = {
          emailid: this.emailid.toLowerCase(),
          name: this.name
        }
        this.SendEmailList.push(obj);
        // this.SendEmailList.push(this.emailid.toLowerCase());        
        this.emailid = "";
        this.name = "";
        this.addButtonShow = false;
      } else {
        this.addButtonShow = false;
        this.toastr.warning("email allready exist.");
      }
    }

  }

  checkEmail(val) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var check = re.test(String(val).toLowerCase());
    if (check == true) {
      this.addButtonShow = true;
    } else {
      this.addButtonShow = false;
    }
  }

  removeEmail(email: any) {
    let removeIndex = this.SendEmailList.findIndex((itm) => itm.emailid === email);
    if (removeIndex !== -1) this.SendEmailList.splice(removeIndex, 1);
    //this.SendEmailList = this.SendEmailList.filter(m => m.emailid!== email);
  }

  removeCore(email: any) {
    let removeIndex = this.selectCoreList.findIndex((itm) => itm.emailid === email);
    if (removeIndex !== -1) this.selectCoreList.splice(removeIndex, 1);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkMobileNo(val) {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    var check = phoneNumberregex.test(String(val).toLowerCase());
    if (check == true) {
      this.addButtonShow = true;
    } else {
      this.addButtonShow = false;
    }
  }

  AddMobileNo(e: any) {
    if (this.name == "") {
      this.toastr.warning("Please add name.");
      return;
    }
    if (this.SendMobileList.length >= 5) {
      this.toastr.warning("only 5 mobile no. are allowed.");
    } else {
      var check = [];
      check = this.SendMobileList.filter(m => m === e.target.value);
      if (check.length > 0) {
        this.toastr.warning("Mobile no. allready exist.");
      } else {
        var obj = {
          mobile: e.target.value.toLowerCase(),
          name: this.name
        }
        this.SendMobileList.push(obj);
        //this.SendMobileList.push(e.target.value.toLowerCase());
        e.target.value = '';
        this.mobileNo = "";
        this.name = "";
      }
    }
  }

  addMobilesNo() {
    if (this.SendMobileList.length >= 5) {
      this.toastr.warning("only 5 Mobile no. are allowed.");
    } else {
      if (!this.SendMobileList.includes(this.mobileNo.trim().toLowerCase())) {
        var obj = {
          mobile: this.mobileNo.trim().toLowerCase(),
          name: this.name
        }
        this.SendMobileList.push(obj);
        // this.SendMobileList.push(this.mobileNo.trim().toLowerCase());
        this.mobileNo = "";
        this.name = "";
        this.addButtonShow = false;
      } else {
        this.addButtonShow = false;
        this.toastr.warning("Mobile no. allready exist.");
      }
    }

  }

  removeMobile(mobile: any) {
    let removeIndex = this.SendMobileList.findIndex((m) => m.mobile === mobile);
    if (removeIndex !== -1) this.SendMobileList.splice(removeIndex, 1);
    //this.SendMobileList = this.SendMobileList.filter(m => m.mobile !== mobile);
  }

  showOptions(event: MatCheckboxChange, data): void {
    if (data == "Attach") {
      this.AttachChecked = event.checked;
    }
    if (data == "Assignee") {
      this.AssigneeChecked = event.checked;
    }
    if (data == "Notify") {
      this.NotifyChecked = event.checked;
    }
    if (data == "SendEmailLater") {
      this.SendEmailLater = event.checked;
    }
  }

  closeSendTaskListURL() {
    this.name = "";
    this.spinner = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.selectCoreList = [];
    this.dialog.closeAll();
  }


  SendEmailForTaskListURL(SendEmailLater:boolean) {
    if (this.selectCoreList.length > 0) {
      var coreList = [];
      for (let i = 0; i < this.selectCoreList.length; i++) {
        if (this.selectCoreList[i].isNotASigner == false) {
          this.selectCoreList[i].contactAttachWithCores = [];
        }
        if (this.selectCoreList[i].isNotASigner == true) {
          if (this.selectCoreList[i].contactAttachWithCores.length == 0) {
            this.toastr.warning('Please add ' + this.orgModuleNameContact + '', '', {
              timeOut: 4000,
            });
            return;
          }
          if (this.selectCoreList[i].contactAttachWithCores.length > 0) {
            if (this.relationList.length > 0) {
              var checkRelation: number = 0;
              checkRelation = this.selectCoreList[i].contactAttachWithCores[0].TransctionalRoleID;
              if (checkRelation == 0) {
                this.toastr.warning('Please Select Relation', '', {
                  timeOut: 4000,
                });
                return;
              }
            }
          }
        }

        var objcore = {
          cType: 1,
          cid: this.selectCoreList[i].coreID,
          name: this.selectCoreList[i].name,
          emailMobile: this.selectCoreList[i].emailid,
          messageType: 0, //0-Core ,1-Email , 2-Mobile
          contactAttachWithCores: this.selectCoreList[i].contactAttachWithCores,
          isNotASigner: this.selectCoreList[i].isNotASigner != undefined ? this.selectCoreList[i].isNotASigner : false
        }
        coreList.push(objcore);
      }
    }
    var ReqModel1 = {
      taskListID: 0,
      taskListName: this.TaskListName,
      position: 0,
      folderID: this.taskListFolderID,
      taskTemplateID: this.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      emailMessageTos: coreList,
      isChildDueDate: false,
      sendEmailLater: SendEmailLater,
      keepAssignee: this.AssigneeChecked,
    }
    this.loaderService.show();
    this.ButtonForFolder = false;
    this.spinner = true;
    this.selectCoreList = [];
    this.taskService.SendEmailForTaskListURL(ReqModel1).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Tasklist url is successfully added .', '', {
            timeOut: 3000,
          });
          this.name = "";
          this.mobileNo = "";
          this.addButtonShow = false;
          this.AddTaskListEmailResult = this.responseHolder.data;
          this.AddTaskListEmailResult.forEach(el => {
            el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
          });
          this.loaderService.hide();
          this.SendMobileList = [];
          this.selectCoreList = [];
          this.closeSendTaskListURL();
          this.RecallSendEmailForTaskListURL(ReqModel1, response.data.map(m => m.taskListID));
        } else {
          this.selectCoreList = [];
          this.loaderService.hide();
          this.toastr.error(this.responseHolder.message, '', {
           timeOut: 3000,
          });
        }
      } else {
        this.name = "";
        this.mobileNo = "";
        this.addButtonShow = false;
        this.SendMobileList = [];
        this.selectCoreList = [];
        this.loaderService.hide();
      }
    });
  }

  SendEmailForTaskListURL1() {
    // if(this.showEmail==true){
    //   if(this.SendEmailList.length>0){
    //     var emailList=[];
    //     for (let i = 0; i < this.SendEmailList.length; i++) {
    //       var obj={
    //         name:this.SendEmailList[i].name,
    //         emailMobile:this.SendEmailList[i].emailid,
    //         messageType:1 // 1-Email , 2-Mobile
    //       }
    //       emailList.push(obj);
    //     }       
    //   }      

    //   var ReqModel = {
    //     taskListID: 0,
    //     taskListName: this.TaskListName,
    //     position: 0,
    //     folderID: this.taskListFolderID,
    //     taskTemplateID: this.taskTemplateID,
    //     userID: this.currentUser.UID,
    //     organizationID: Number(this.organizationId),
    //     officeID: Number(this.myOfficeID),
    //     emailMessageTos:emailList,
    //     //SendEmailList: this.SendEmailList,
    //     IsChildDueDate: false,
    //     keepAttached: false,//this.AttachChecked,
    //     keepAssignee: this.AssigneeChecked,
    //     keepNotify: this.NotifyChecked,
    //   }
    //  // return;
    //   this.loaderService.show();
    //   this.ButtonForFolder = false;
    //   this.spinner = true;
    //   this.taskService.SendEmailForTaskListURL(ReqModel).subscribe(response => {
    //     if (response != undefined) {
    //       this.responseHolder = response;
    //       this.spinner = false;
    //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {
    //         this.toastr.success('Task List added in task template successfully.', '', {
    //           timeOut: 3000,
    //         });
    //         this.name="";
    //         this.emailid = "";
    //         this.addButtonShow = false;
    //         this.AddTaskListEmailResult = this.responseHolder.data;
    //         this.AddTaskListEmailResult.forEach(el => {
    //           el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
    //         });
    //         //this.SendExternalURLEmail();
    //         this.loaderService.hide();
    //         this.SendEmailList = [];
    //         this.closeSendTaskListURL();
    //         this.RecallSendEmailForTaskListURL(ReqModel, response.data.map(m => m.taskListID));
    //       }
    //     } else {
    //       this.name="";
    //       this.emailid = "";
    //       this.addButtonShow = false;
    //       this.SendEmailList = [];
    //       this.loaderService.hide();
    //     }
    //   });
    // }

    // if(this.showMobile==true){
    //   if(this.SendMobileList.length>0){
    //     var mobileList=[];
    //     for (let i = 0; i < this.SendMobileList.length; i++) {
    //       var obj={
    //         name:this.SendMobileList[i].name,
    //         emailMobile:this.SendMobileList[i].mobile,
    //         messageType:2 // 1-Email , 2-Mobile
    //       }
    //       mobileList.push(obj);
    //     }       
    //   }
    //   var ReqModel1 = {
    //     taskListID: 0,
    //     taskListName: this.TaskListName,
    //     position: 0,
    //     folderID: this.taskListFolderID,
    //     taskTemplateID: this.taskTemplateID,
    //     userID: this.currentUser.UID,
    //     organizationID: Number(this.organizationId),
    //     officeID: Number(this.myOfficeID),
    //     emailMessageTos:mobileList,
    //    // SendEmailList: this.SendMobileList,
    //     isChildDueDate: false
    //   }
    //   this.loaderService.show();
    //   this.ButtonForFolder = false;
    //   this.spinner = true;
    //   this.taskService.SendEmailForTaskListURL(ReqModel1).subscribe(response => {
    //     if (response != undefined) {
    //       this.responseHolder = response;
    //       this.spinner = false;
    //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {
    //         this.toastr.success('Tasklist url is successfully sent to mobile.', '', {
    //           timeOut: 3000,
    //         });
    //         this.name="";
    //         this.mobileNo = "";
    //         this.addButtonShow = false;
    //         this.AddTaskListEmailResult = this.responseHolder.data;
    //         this.AddTaskListEmailResult.forEach(el => {
    //           el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
    //         });
    //         //this.SendExternalURLEmail();
    //         this.loaderService.hide();
    //         this.SendMobileList = [];
    //         this.closeSendTaskListURL();
    //         this.RecallSendEmailForTaskListURL(ReqModel1, response.data.map(m => m.taskListID));
    //       }
    //     } else {
    //       this.name="";
    //       this.mobileNo = "";
    //       this.addButtonShow = false;
    //       this.SendMobileList = [];
    //       this.loaderService.hide();
    //     }
    //   });
    // }

    // if(this.showSearchCore==true){
    if (this.selectCoreList.length > 0) {
      var coreList = [];
      for (let i = 0; i < this.selectCoreList.length; i++) {
        var objcore = {
          cType: 1,
          cid: this.selectCoreList[i].coreID,
          name: this.selectCoreList[i].name,
          emailMobile: this.selectCoreList[i].emailid,
          messageType: 0, //0-Core ,1-Email , 2-Mobile
          contactAttachWithCores: this.selectCoreList[i].contactAttachWithCores,
          isNotASigner: this.selectCoreList[i].isNotASigner != undefined ? this.selectCoreList[i].isNotASigner : false
        }
        coreList.push(objcore);
      }
    }
    var ReqModel1 = {
      taskListID: 0,
      taskListName: this.TaskListName,
      position: 0,
      folderID: this.taskListFolderID,
      taskTemplateID: this.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      emailMessageTos: coreList,
      isChildDueDate: false,
      sendEmailLater: this.SendEmailLater,
      keepAssignee: this.AssigneeChecked,
    }
    this.loaderService.show();
    this.ButtonForFolder = false;
    this.spinner = true;
    this.selectCoreList = [];
    this.taskService.SendEmailForTaskListURL(ReqModel1).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Tasklist url is successfully added .', '', {
            timeOut: 3000,
          });
          this.name = "";
          this.mobileNo = "";
          this.addButtonShow = false;
          this.AddTaskListEmailResult = this.responseHolder.data;
          this.AddTaskListEmailResult.forEach(el => {
            el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
          });
          this.loaderService.hide();
          this.SendMobileList = [];
          this.selectCoreList = [];
          this.closeSendTaskListURL();
          this.RecallSendEmailForTaskListURL(ReqModel1, response.data.map(m => m.taskListID));
        } else {
          this.selectCoreList = [];
          this.loaderService.hide();
        }
      } else {
        this.name = "";
        this.mobileNo = "";
        this.addButtonShow = false;
        this.SendMobileList = [];
        this.selectCoreList = [];
        this.loaderService.hide();
      }
    });
    //}
  }

  RecallSendEmailForTaskListURL(ReqModel, taskListIDs) {
    ReqModel.IsChildDueDate = true;
    ReqModel.ChildTaskListIDs = taskListIDs;
    this.taskService.SendEmailForTaskListURL(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Child Task List added in task template successfully.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.name = "";
        this.emailid = "";
        this.savebuttonshow = false;
        this.SendEmailList = [];
        this.loaderService.hide();
      }
    });
  }


  objectList: any = [] = [];
  timeout = null;
  selectCoreList: any = [];
  showSearchCore: boolean = false;
  attachedToCoreList: any = [] = [];
  roleIdList: any = [];
  searchName: string = '';
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue: string;
  states = this.objectList;
  isShare: false;
  showAddCore: boolean = false;
  mainModuleName: string = '';
  folderID: number = 0;
  selectedCoreId: number = 0;
  sendFrom: string = "SendTasklist";
  TaskListName: string = "";
  @ViewChild('SendTaskListURL', { static: true }) SendTaskListURLTemplate: TemplateRef<any>;
  taskTemplateAfterAddingCore: any;
  checkedByDefaultEmail = true;
  checkedByDefaultCore = false;

  searchCore(val) {
    this.attachedToCoreList = [];
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.attachedToCoreList = response.data;
          this.attachedToCoreList.push({
            coreID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            shortName: '',
          });
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }

  //************** */
  ///***************************** */

  searchContacts(val) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }
  getsearchContact(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formsService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.attachedToContactList = response.data;
          this.attachedToContactList.push({
            contactID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            shortName: '',
          });
        } else {
          this.attachedToContactList = [];
        }
      }
    })
  }
  OnChnageRelation($event, email) {
    this.selectCoreList.find(m => m.coreID == email.coreID).contactAttachWithCores[0].TransctionalRoleID = $event.value;
  }
  //====== For Add Contact  ================//
  contactSelectedNew(contactSelected: any, emailid) {

    var check = [];
    this.contactsSelectedList = [];
    if (this.selectCoreList.find(m => m.emailid == emailid).contactAttachWithCores.length > 0) {
      check = this.selectCoreList.find(m => m.emailid == emailid).contactAttachWithCores.filter(x => x.contactID == contactSelected.contactID);
      if (check.length > 0) {
        this.stateCtrl.setValue('');
        this.toastr.warning('Selected ' + this.orgModuleNameContact + ' is allready added.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    if (contactSelected.contactID == 0) {
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.addNewCore('Contact', emailid);
      return;
    }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');

    var obj = {
      name: contactSelected.name,
      email: contactSelected.email,
      contactID: contactSelected.contactID,
      img: contactSelected.imageUrl,
      shortName: shortName,
      TransctionalRoleID: 0
    }
    this.contactsSelectedList.push(obj);
    this.selectCoreList.find(m => m.emailid == emailid).contactAttachWithCores = this.contactsSelectedList;
  }

  ////******************* */

  onNotASignerChange(event: Event, email: any) {
    let isTasklistCheckboxChecked = (event.target as HTMLInputElement).checked;
    this.selectCoreList.find(m => m.emailid == email.emailid).isNotASigner = isTasklistCheckboxChecked;
    // if(isTasklistCheckboxChecked==true)
    // {
    // document.getElementById('1_Search' + email.emailid).style.display="block";
    // }
    // else
    // {
    // document.getElementById('1_Search' + email.emailid).style.display="none";
    // }
  }

  //************** */
  coreSelected(coreSelected: any) {
    var check = [];
    check = this.selectCoreList.filter(x => x.coreID == coreSelected.coreID);
    if (check.length > 0) {
      this.stateCtrl.setValue('');
      this.toastr.warning('Selected ' + this.orgModuleNameCore + ' is allready added.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (coreSelected.coreID == 0) {
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.addNewCore('Core');
      return;
    }
    this.selectedCoreEmailID = coreSelected.email;
    this.selectCoreList.push({
      name: coreSelected.name,
      emailid: coreSelected.email,
      img: coreSelected.imageUrl,
      coreID: coreSelected.coreID,
      shortName: coreSelected.shortName,
      isNotASigner: false,
      contactAttachWithCores: []
    });
    this.stateCtrl.setValue('');
    if (this.selectCoreList.length > 0) {
    }
    else {
    }
  }

  addNewCore(module, emailid = '') {
    this.mainModuleName = module;
    var menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var Module = menuModulesList.filter((x) => x.mainModuleName == module);
    var Modulename = Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddCore = !this.showAddCore;
    this.selectedCoreEmailID = emailid;
  }

  getCloseCore(message) {
    this.showAddCore = message;
  }

  getselectedTransactionId(result) {
    if (result.FromModuleName == 'Core') {

      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      this.selectedCoreEmailID = result.email;
      this.selectCoreList.push({
        name: result.name,
        emailid: result.email,
        img: "",
        coreID: result.transactionId,
        shortName: shortName,
        isNotASigner: false,
        contactAttachWithCores: []
      });
      if (this.selectCoreList.length > 0) {
      }
      else {
      }
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
    }
    else if (result.FromModuleName == 'Contact') {
      this.contactsSelectedList = [];
      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      this.contactsSelectedList.push({
        name: result.name,
        email: result.email,
        img: "",
        contactID: result.transactionId,
        shortName: shortName,
        TransctionalRoleID: 0
      });
      if (this.selectCoreList.find(m => m.emailid == this.selectedCoreEmailID)) {
        this.selectCoreList.find(m => m.emailid == this.selectedCoreEmailID).contactAttachWithCores = this.contactsSelectedList;
      }
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
    }
    if (result == "Close") {
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
    }
  }

  removeContactWithCoreCore(core) {
    this.selectedCoreEmailID = core.emailid;
    this.selectCoreList.find(m => m.emailid == core.emailid).contactAttachWithCores = [];
    this.contactsSelectedList = [];
  }

  OpenFolderSendEmailAddingCore(templateRef: TemplateRef<any>, taskTemplate: any) {
    this.TaskListName = taskTemplate.templateName;
    this.name = "";
    this.emailid = "";
    this.addButtonShow = false;
    this.SendEmailList = [];

    this.AttachChecked = false;
    this.AssigneeChecked = true;
    this.NotifyChecked = false;
    this.SendEmailLater = false;

    this.searchName = "";
    this.checkedByDefaultEmail = false;
    this.checkedByDefaultCore = true;
    this.showSearchCore = true;
    this.attachedToCoreList = [];

    this.taskTemplateID = taskTemplate.id;
    if (taskTemplate.taskListFolderID > 0) {
      this.taskListFolderID = taskTemplate.taskListFolderID;
    } else {
      this.taskListFolderID = 0;
    }

    this.showTemplateDetailCheckingDuplicateEmail(taskTemplate.id);
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;

    this.showEmail = false;
    this.showMobile = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.emailid = "";
    this.mobileNo = "";
    this.sendButton = false;
    this.stateCtrl.setValue('');
    this.dialog.open(templateRef);

  }

  showDetail: boolean = false;
  mainModuleNameForDetails: string = "";

  editCore(data: any) {
    this.mainModuleNameForDetails = "Core";
    this.transactionID = data.coreID;
    this.showDetail = !this.showDetail;
    this.dialog.closeAll();
  }

  getUpdatedRecord(result) {
    if (result.FromModuleName == 'Core') {
      if (this.selectCoreList.length > 0) {
        this.selectCoreList.find((item) => item.coreID == result.transactionId).name = result.name;
        this.selectCoreList.find((item) => item.coreID == result.transactionId).emailid = result.email;
        this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate, this.taskTemplateAfterAddingCore);
      }
    }
  }

  getCloseDetails(message) {
    this.showDetail = false;
  }

  MailToAssignee(item) {
    var ReqModel = {
       taskListID: Number(item.taskListID),        
       userID: this.currentUser.UID,
       organizationID: Number(this.organizationId),
       officeID: this.myOfficeID,
       officeIDList: this.OfficeIDList,
       databaseID: Number(this.databaseId)
     };
     this.loaderService.show();
     this.taskService.resendTasklistURL(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         this.loaderService.hide();
         if (this.responseHolder.status == this.statusConstant.statusSuccess) { 
           this.toastr.success('Mail sent to assignee successfully.', '', {
             timeOut: 4000,
           });                      
           this.loaderService.hide();
           if(item.isSharedTasklist==true){
            this.getTaskListByType(2);
           }
           if(item.isSharedTasklist==false){
            this.getTaskListByType(1);
           }    
         } else {
           this.toastr.error('Failed to send mail to assignee.', '', {
             timeOut: 4000,
           }); 
           this.loaderService.hide();
         }
       } else {
         this.toastr.error('Failed to send mail to assignee.', '', {
           timeOut: 4000,
         }); 
         this.loaderService.hide();
       }
     });
 }

}
